import * as f from "react";
import it, { useLayoutEffect as vi, useState as We, useEffect as fr, createContext as hi, useContext as mi, useRef as Rn, forwardRef as Pn, useCallback as gi, useMemo as dr } from "react";
import * as Tn from "react-dom";
import yi from "react-dom";
import $e, { keyframes as An, useTheme as On } from "styled-components";
import { Typography as _n, Icons as Dn } from "@flash-tecnologia/hros-web-ui-v2";
function bi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var or = { exports: {} }, nt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wr;
function wi() {
  if (Wr) return nt;
  Wr = 1;
  var e = it, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, c, l) {
    var u, d = {}, v = null, h = null;
    l !== void 0 && (v = "" + l), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (h = c.ref);
    for (u in c) n.call(c, u) && !i.hasOwnProperty(u) && (d[u] = c[u]);
    if (a && a.defaultProps) for (u in c = a.defaultProps, c) d[u] === void 0 && (d[u] = c[u]);
    return { $$typeof: t, type: a, key: v, ref: h, props: d, _owner: o.current };
  }
  return nt.Fragment = r, nt.jsx = s, nt.jsxs = s, nt;
}
var ot = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Br;
function xi() {
  return Br || (Br = 1, process.env.NODE_ENV !== "production" && function() {
    var e = it, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), y = Symbol.iterator, m = "@@iterator";
    function b(p) {
      if (p === null || typeof p != "object")
        return null;
      var S = y && p[y] || p[m];
      return typeof S == "function" ? S : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(p) {
      {
        for (var S = arguments.length, A = new Array(S > 1 ? S - 1 : 0), M = 1; M < S; M++)
          A[M - 1] = arguments[M];
        R("error", p, A);
      }
    }
    function R(p, S, A) {
      {
        var M = w.ReactDebugCurrentFrame, J = M.getStackAddendum();
        J !== "" && (S += "%s", A = A.concat([J]));
        var re = A.map(function(q) {
          return String(q);
        });
        re.unshift("Warning: " + S), Function.prototype.apply.call(console[p], console, re);
      }
    }
    var C = !1, g = !1, D = !1, _ = !1, V = !1, L;
    L = Symbol.for("react.module.reference");
    function F(p) {
      return !!(typeof p == "string" || typeof p == "function" || p === n || p === i || V || p === o || p === l || p === u || _ || p === h || C || g || D || typeof p == "object" && p !== null && (p.$$typeof === v || p.$$typeof === d || p.$$typeof === s || p.$$typeof === a || p.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      p.$$typeof === L || p.getModuleId !== void 0));
    }
    function te(p, S, A) {
      var M = p.displayName;
      if (M)
        return M;
      var J = S.displayName || S.name || "";
      return J !== "" ? A + "(" + J + ")" : A;
    }
    function ne(p) {
      return p.displayName || "Context";
    }
    function K(p) {
      if (p == null)
        return null;
      if (typeof p.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof p == "function")
        return p.displayName || p.name || null;
      if (typeof p == "string")
        return p;
      switch (p) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case l:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case a:
            var S = p;
            return ne(S) + ".Consumer";
          case s:
            var A = p;
            return ne(A._context) + ".Provider";
          case c:
            return te(p, p.render, "ForwardRef");
          case d:
            var M = p.displayName || null;
            return M !== null ? M : K(p.type) || "Memo";
          case v: {
            var J = p, re = J._payload, q = J._init;
            try {
              return K(q(re));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, oe = 0, Z, G, N, ie, x, O, W;
    function $() {
    }
    $.__reactDisabledLog = !0;
    function j() {
      {
        if (oe === 0) {
          Z = console.log, G = console.info, N = console.warn, ie = console.error, x = console.group, O = console.groupCollapsed, W = console.groupEnd;
          var p = {
            configurable: !0,
            enumerable: !0,
            value: $,
            writable: !0
          };
          Object.defineProperties(console, {
            info: p,
            log: p,
            warn: p,
            error: p,
            group: p,
            groupCollapsed: p,
            groupEnd: p
          });
        }
        oe++;
      }
    }
    function H() {
      {
        if (oe--, oe === 0) {
          var p = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, p, {
              value: Z
            }),
            info: z({}, p, {
              value: G
            }),
            warn: z({}, p, {
              value: N
            }),
            error: z({}, p, {
              value: ie
            }),
            group: z({}, p, {
              value: x
            }),
            groupCollapsed: z({}, p, {
              value: O
            }),
            groupEnd: z({}, p, {
              value: W
            })
          });
        }
        oe < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var k = w.ReactCurrentDispatcher, I;
    function B(p, S, A) {
      {
        if (I === void 0)
          try {
            throw Error();
          } catch (J) {
            var M = J.stack.trim().match(/\n( *(at )?)/);
            I = M && M[1] || "";
          }
        return `
` + I + p;
      }
    }
    var U = !1, Y;
    {
      var ce = typeof WeakMap == "function" ? WeakMap : Map;
      Y = new ce();
    }
    function T(p, S) {
      if (!p || U)
        return "";
      {
        var A = Y.get(p);
        if (A !== void 0)
          return A;
      }
      var M;
      U = !0;
      var J = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var re;
      re = k.current, k.current = null, j();
      try {
        if (S) {
          var q = function() {
            throw Error();
          };
          if (Object.defineProperty(q.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(q, []);
            } catch (_e) {
              M = _e;
            }
            Reflect.construct(p, [], q);
          } else {
            try {
              q.call();
            } catch (_e) {
              M = _e;
            }
            p.call(q.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (_e) {
            M = _e;
          }
          p();
        }
      } catch (_e) {
        if (_e && M && typeof _e.stack == "string") {
          for (var X = _e.stack.split(`
`), ue = M.stack.split(`
`), ae = X.length - 1, se = ue.length - 1; ae >= 1 && se >= 0 && X[ae] !== ue[se]; )
            se--;
          for (; ae >= 1 && se >= 0; ae--, se--)
            if (X[ae] !== ue[se]) {
              if (ae !== 1 || se !== 1)
                do
                  if (ae--, se--, se < 0 || X[ae] !== ue[se]) {
                    var ge = `
` + X[ae].replace(" at new ", " at ");
                    return p.displayName && ge.includes("<anonymous>") && (ge = ge.replace("<anonymous>", p.displayName)), typeof p == "function" && Y.set(p, ge), ge;
                  }
                while (ae >= 1 && se >= 0);
              break;
            }
        }
      } finally {
        U = !1, k.current = re, H(), Error.prepareStackTrace = J;
      }
      var He = p ? p.displayName || p.name : "", Fr = He ? B(He) : "";
      return typeof p == "function" && Y.set(p, Fr), Fr;
    }
    function le(p, S, A) {
      return T(p, !1);
    }
    function Te(p) {
      var S = p.prototype;
      return !!(S && S.isReactComponent);
    }
    function Ae(p, S, A) {
      if (p == null)
        return "";
      if (typeof p == "function")
        return T(p, Te(p));
      if (typeof p == "string")
        return B(p);
      switch (p) {
        case l:
          return B("Suspense");
        case u:
          return B("SuspenseList");
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case c:
            return le(p.render);
          case d:
            return Ae(p.type, S, A);
          case v: {
            var M = p, J = M._payload, re = M._init;
            try {
              return Ae(re(J), S, A);
            } catch {
            }
          }
        }
      return "";
    }
    var Ve = Object.prototype.hasOwnProperty, ft = {}, dt = w.ReactDebugCurrentFrame;
    function Oe(p) {
      if (p) {
        var S = p._owner, A = Ae(p.type, p._source, S ? S.type : null);
        dt.setExtraStackFrame(A);
      } else
        dt.setExtraStackFrame(null);
    }
    function qo(p, S, A, M, J) {
      {
        var re = Function.call.bind(Ve);
        for (var q in p)
          if (re(p, q)) {
            var X = void 0;
            try {
              if (typeof p[q] != "function") {
                var ue = Error((M || "React class") + ": " + A + " type `" + q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof p[q] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ue.name = "Invariant Violation", ue;
              }
              X = p[q](S, q, M, A, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ae) {
              X = ae;
            }
            X && !(X instanceof Error) && (Oe(J), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", M || "React class", A, q, typeof X), Oe(null)), X instanceof Error && !(X.message in ft) && (ft[X.message] = !0, Oe(J), E("Failed %s type: %s", A, X.message), Oe(null));
          }
      }
    }
    var Ko = Array.isArray;
    function $t(p) {
      return Ko(p);
    }
    function Zo(p) {
      {
        var S = typeof Symbol == "function" && Symbol.toStringTag, A = S && p[Symbol.toStringTag] || p.constructor.name || "Object";
        return A;
      }
    }
    function Go(p) {
      try {
        return Or(p), !1;
      } catch {
        return !0;
      }
    }
    function Or(p) {
      return "" + p;
    }
    function _r(p) {
      if (Go(p))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Zo(p)), Or(p);
    }
    var rt = w.ReactCurrentOwner, Jo = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Dr, Lr, Ft;
    Ft = {};
    function Qo(p) {
      if (Ve.call(p, "ref")) {
        var S = Object.getOwnPropertyDescriptor(p, "ref").get;
        if (S && S.isReactWarning)
          return !1;
      }
      return p.ref !== void 0;
    }
    function ei(p) {
      if (Ve.call(p, "key")) {
        var S = Object.getOwnPropertyDescriptor(p, "key").get;
        if (S && S.isReactWarning)
          return !1;
      }
      return p.key !== void 0;
    }
    function ti(p, S) {
      if (typeof p.ref == "string" && rt.current && S && rt.current.stateNode !== S) {
        var A = K(rt.current.type);
        Ft[A] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', K(rt.current.type), p.ref), Ft[A] = !0);
      }
    }
    function ri(p, S) {
      {
        var A = function() {
          Dr || (Dr = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
        };
        A.isReactWarning = !0, Object.defineProperty(p, "key", {
          get: A,
          configurable: !0
        });
      }
    }
    function ni(p, S) {
      {
        var A = function() {
          Lr || (Lr = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
        };
        A.isReactWarning = !0, Object.defineProperty(p, "ref", {
          get: A,
          configurable: !0
        });
      }
    }
    var oi = function(p, S, A, M, J, re, q) {
      var X = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: p,
        key: S,
        ref: A,
        props: q,
        // Record the component responsible for creating this element.
        _owner: re
      };
      return X._store = {}, Object.defineProperty(X._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(X, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: M
      }), Object.defineProperty(X, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: J
      }), Object.freeze && (Object.freeze(X.props), Object.freeze(X)), X;
    };
    function ii(p, S, A, M, J) {
      {
        var re, q = {}, X = null, ue = null;
        A !== void 0 && (_r(A), X = "" + A), ei(S) && (_r(S.key), X = "" + S.key), Qo(S) && (ue = S.ref, ti(S, J));
        for (re in S)
          Ve.call(S, re) && !Jo.hasOwnProperty(re) && (q[re] = S[re]);
        if (p && p.defaultProps) {
          var ae = p.defaultProps;
          for (re in ae)
            q[re] === void 0 && (q[re] = ae[re]);
        }
        if (X || ue) {
          var se = typeof p == "function" ? p.displayName || p.name || "Unknown" : p;
          X && ri(q, se), ue && ni(q, se);
        }
        return oi(p, X, ue, J, M, rt.current, q);
      }
    }
    var Wt = w.ReactCurrentOwner, Mr = w.ReactDebugCurrentFrame;
    function ze(p) {
      if (p) {
        var S = p._owner, A = Ae(p.type, p._source, S ? S.type : null);
        Mr.setExtraStackFrame(A);
      } else
        Mr.setExtraStackFrame(null);
    }
    var Bt;
    Bt = !1;
    function Yt(p) {
      return typeof p == "object" && p !== null && p.$$typeof === t;
    }
    function jr() {
      {
        if (Wt.current) {
          var p = K(Wt.current.type);
          if (p)
            return `

Check the render method of \`` + p + "`.";
        }
        return "";
      }
    }
    function ai(p) {
      return "";
    }
    var kr = {};
    function si(p) {
      {
        var S = jr();
        if (!S) {
          var A = typeof p == "string" ? p : p.displayName || p.name;
          A && (S = `

Check the top-level render call using <` + A + ">.");
        }
        return S;
      }
    }
    function Ir(p, S) {
      {
        if (!p._store || p._store.validated || p.key != null)
          return;
        p._store.validated = !0;
        var A = si(S);
        if (kr[A])
          return;
        kr[A] = !0;
        var M = "";
        p && p._owner && p._owner !== Wt.current && (M = " It was passed a child from " + K(p._owner.type) + "."), ze(p), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', A, M), ze(null);
      }
    }
    function Nr(p, S) {
      {
        if (typeof p != "object")
          return;
        if ($t(p))
          for (var A = 0; A < p.length; A++) {
            var M = p[A];
            Yt(M) && Ir(M, S);
          }
        else if (Yt(p))
          p._store && (p._store.validated = !0);
        else if (p) {
          var J = b(p);
          if (typeof J == "function" && J !== p.entries)
            for (var re = J.call(p), q; !(q = re.next()).done; )
              Yt(q.value) && Ir(q.value, S);
        }
      }
    }
    function ci(p) {
      {
        var S = p.type;
        if (S == null || typeof S == "string")
          return;
        var A;
        if (typeof S == "function")
          A = S.propTypes;
        else if (typeof S == "object" && (S.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        S.$$typeof === d))
          A = S.propTypes;
        else
          return;
        if (A) {
          var M = K(S);
          qo(A, p.props, "prop", M, p);
        } else if (S.PropTypes !== void 0 && !Bt) {
          Bt = !0;
          var J = K(S);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", J || "Unknown");
        }
        typeof S.getDefaultProps == "function" && !S.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function li(p) {
      {
        for (var S = Object.keys(p.props), A = 0; A < S.length; A++) {
          var M = S[A];
          if (M !== "children" && M !== "key") {
            ze(p), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", M), ze(null);
            break;
          }
        }
        p.ref !== null && (ze(p), E("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    function $r(p, S, A, M, J, re) {
      {
        var q = F(p);
        if (!q) {
          var X = "";
          (p === void 0 || typeof p == "object" && p !== null && Object.keys(p).length === 0) && (X += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ue = ai();
          ue ? X += ue : X += jr();
          var ae;
          p === null ? ae = "null" : $t(p) ? ae = "array" : p !== void 0 && p.$$typeof === t ? (ae = "<" + (K(p.type) || "Unknown") + " />", X = " Did you accidentally export a JSX literal instead of a component?") : ae = typeof p, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ae, X);
        }
        var se = ii(p, S, A, J, re);
        if (se == null)
          return se;
        if (q) {
          var ge = S.children;
          if (ge !== void 0)
            if (M)
              if ($t(ge)) {
                for (var He = 0; He < ge.length; He++)
                  Nr(ge[He], p);
                Object.freeze && Object.freeze(ge);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nr(ge, p);
        }
        return p === n ? li(se) : ci(se), se;
      }
    }
    function ui(p, S, A) {
      return $r(p, S, A, !0);
    }
    function fi(p, S, A) {
      return $r(p, S, A, !1);
    }
    var di = fi, pi = ui;
    ot.Fragment = n, ot.jsx = di, ot.jsxs = pi;
  }()), ot;
}
process.env.NODE_ENV === "production" ? or.exports = wi() : or.exports = xi();
var P = or.exports;
function fe(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), r === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Yr(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function pr(...e) {
  return (t) => {
    let r = !1;
    const n = e.map((o) => {
      const i = Yr(o, t);
      return !r && typeof i == "function" && (r = !0), i;
    });
    if (r)
      return () => {
        for (let o = 0; o < n.length; o++) {
          const i = n[o];
          typeof i == "function" ? i() : Yr(e[o], null);
        }
      };
  };
}
function de(...e) {
  return f.useCallback(pr(...e), e);
}
function vr(e, t = []) {
  let r = [];
  function n(i, s) {
    const a = f.createContext(s), c = r.length;
    r = [...r, s];
    const l = (d) => {
      var w;
      const { scope: v, children: h, ...y } = d, m = ((w = v == null ? void 0 : v[e]) == null ? void 0 : w[c]) || a, b = f.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ P.jsx(m.Provider, { value: b, children: h });
    };
    l.displayName = i + "Provider";
    function u(d, v) {
      var m;
      const h = ((m = v == null ? void 0 : v[e]) == null ? void 0 : m[c]) || a, y = f.useContext(h);
      if (y) return y;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [l, u];
  }
  const o = () => {
    const i = r.map((s) => f.createContext(s));
    return function(a) {
      const c = (a == null ? void 0 : a[e]) || i;
      return f.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: c } }),
        [a, c]
      );
    };
  };
  return o.scopeName = e, [n, Ei(o, ...t)];
}
function Ei(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = n.reduce((a, { useScope: c, scopeName: l }) => {
        const d = c(i)[`__scope${l}`];
        return { ...a, ...d };
      }, {});
      return f.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
// @__NO_SIDE_EFFECTS__
function Si(e) {
  const t = /* @__PURE__ */ Ci(e), r = f.forwardRef((n, o) => {
    const { children: i, ...s } = n, a = f.Children.toArray(i), c = a.find(Pi);
    if (c) {
      const l = c.props.children, u = a.map((d) => d === c ? f.Children.count(l) > 1 ? f.Children.only(null) : f.isValidElement(l) ? l.props.children : null : d);
      return /* @__PURE__ */ P.jsx(t, { ...s, ref: o, children: f.isValidElement(l) ? f.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ P.jsx(t, { ...s, ref: o, children: i });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function Ci(e) {
  const t = f.forwardRef((r, n) => {
    const { children: o, ...i } = r;
    if (f.isValidElement(o)) {
      const s = Ai(o), a = Ti(i, o.props);
      return o.type !== f.Fragment && (a.ref = n ? pr(n, s) : s), f.cloneElement(o, a);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Ri = Symbol("radix.slottable");
function Pi(e) {
  return f.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Ri;
}
function Ti(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? o && i ? r[n] = (...a) => {
      const c = i(...a);
      return o(...a), c;
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...i } : n === "className" && (r[n] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Ai(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Oi = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], pe = Oi.reduce((e, t) => {
  const r = /* @__PURE__ */ Si(`Primitive.${t}`), n = f.forwardRef((o, i) => {
    const { asChild: s, ...a } = o, c = s ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ P.jsx(c, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function _i(e, t) {
  e && Tn.flushSync(() => e.dispatchEvent(t));
}
function he(e) {
  const t = f.useRef(e);
  return f.useEffect(() => {
    t.current = e;
  }), f.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
function Di(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = he(e);
  f.useEffect(() => {
    const n = (o) => {
      o.key === "Escape" && r(o);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
var Li = "DismissableLayer", ir = "dismissableLayer.update", Mi = "dismissableLayer.pointerDownOutside", ji = "dismissableLayer.focusOutside", Vr, Ln = f.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Mn = f.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: a,
      ...c
    } = e, l = f.useContext(Ln), [u, d] = f.useState(null), v = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = f.useState({}), y = de(t, (_) => d(_)), m = Array.from(l.layers), [b] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), w = m.indexOf(b), E = u ? m.indexOf(u) : -1, R = l.layersWithOutsidePointerEventsDisabled.size > 0, C = E >= w, g = Ni((_) => {
      const V = _.target, L = [...l.branches].some((F) => F.contains(V));
      !C || L || (o == null || o(_), s == null || s(_), _.defaultPrevented || a == null || a());
    }, v), D = $i((_) => {
      const V = _.target;
      [...l.branches].some((F) => F.contains(V)) || (i == null || i(_), s == null || s(_), _.defaultPrevented || a == null || a());
    }, v);
    return Di((_) => {
      E === l.layers.size - 1 && (n == null || n(_), !_.defaultPrevented && a && (_.preventDefault(), a()));
    }, v), f.useEffect(() => {
      if (u)
        return r && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Vr = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(u)), l.layers.add(u), zr(), () => {
          r && l.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = Vr);
        };
    }, [u, v, r, l]), f.useEffect(() => () => {
      u && (l.layers.delete(u), l.layersWithOutsidePointerEventsDisabled.delete(u), zr());
    }, [u, l]), f.useEffect(() => {
      const _ = () => h({});
      return document.addEventListener(ir, _), () => document.removeEventListener(ir, _);
    }, []), /* @__PURE__ */ P.jsx(
      pe.div,
      {
        ...c,
        ref: y,
        style: {
          pointerEvents: R ? C ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: fe(e.onFocusCapture, D.onFocusCapture),
        onBlurCapture: fe(e.onBlurCapture, D.onBlurCapture),
        onPointerDownCapture: fe(
          e.onPointerDownCapture,
          g.onPointerDownCapture
        )
      }
    );
  }
);
Mn.displayName = Li;
var ki = "DismissableLayerBranch", Ii = f.forwardRef((e, t) => {
  const r = f.useContext(Ln), n = f.useRef(null), o = de(t, n);
  return f.useEffect(() => {
    const i = n.current;
    if (i)
      return r.branches.add(i), () => {
        r.branches.delete(i);
      };
  }, [r.branches]), /* @__PURE__ */ P.jsx(pe.div, { ...e, ref: o });
});
Ii.displayName = ki;
function Ni(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = he(e), n = f.useRef(!1), o = f.useRef(() => {
  });
  return f.useEffect(() => {
    const i = (a) => {
      if (a.target && !n.current) {
        let c = function() {
          jn(
            Mi,
            r,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", o.current);
      n.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function $i(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = he(e), n = f.useRef(!1);
  return f.useEffect(() => {
    const o = (i) => {
      i.target && !n.current && jn(ji, r, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function zr() {
  const e = new CustomEvent(ir);
  document.dispatchEvent(e);
}
function jn(e, t, r, { discrete: n }) {
  const o = r.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && o.addEventListener(e, t, { once: !0 }), n ? _i(o, i) : o.dispatchEvent(i);
}
var Vt = 0;
function Fi() {
  f.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Hr()), document.body.insertAdjacentElement("beforeend", e[1] ?? Hr()), Vt++, () => {
      Vt === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Vt--;
    };
  }, []);
}
function Hr() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var zt = "focusScope.autoFocusOnMount", Ht = "focusScope.autoFocusOnUnmount", Ur = { bubbles: !1, cancelable: !0 }, Wi = "FocusScope", kn = f.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [a, c] = f.useState(null), l = he(o), u = he(i), d = f.useRef(null), v = de(t, (m) => c(m)), h = f.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  f.useEffect(() => {
    if (n) {
      let m = function(R) {
        if (h.paused || !a) return;
        const C = R.target;
        a.contains(C) ? d.current = C : ke(d.current, { select: !0 });
      }, b = function(R) {
        if (h.paused || !a) return;
        const C = R.relatedTarget;
        C !== null && (a.contains(C) || ke(d.current, { select: !0 }));
      }, w = function(R) {
        if (document.activeElement === document.body)
          for (const g of R)
            g.removedNodes.length > 0 && ke(a);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", b);
      const E = new MutationObserver(w);
      return a && E.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", b), E.disconnect();
      };
    }
  }, [n, a, h.paused]), f.useEffect(() => {
    if (a) {
      qr.add(h);
      const m = document.activeElement;
      if (!a.contains(m)) {
        const w = new CustomEvent(zt, Ur);
        a.addEventListener(zt, l), a.dispatchEvent(w), w.defaultPrevented || (Bi(Ui(In(a)), { select: !0 }), document.activeElement === m && ke(a));
      }
      return () => {
        a.removeEventListener(zt, l), setTimeout(() => {
          const w = new CustomEvent(Ht, Ur);
          a.addEventListener(Ht, u), a.dispatchEvent(w), w.defaultPrevented || ke(m ?? document.body, { select: !0 }), a.removeEventListener(Ht, u), qr.remove(h);
        }, 0);
      };
    }
  }, [a, l, u, h]);
  const y = f.useCallback(
    (m) => {
      if (!r && !n || h.paused) return;
      const b = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, w = document.activeElement;
      if (b && w) {
        const E = m.currentTarget, [R, C] = Yi(E);
        R && C ? !m.shiftKey && w === C ? (m.preventDefault(), r && ke(R, { select: !0 })) : m.shiftKey && w === R && (m.preventDefault(), r && ke(C, { select: !0 })) : w === E && m.preventDefault();
      }
    },
    [r, n, h.paused]
  );
  return /* @__PURE__ */ P.jsx(pe.div, { tabIndex: -1, ...s, ref: v, onKeyDown: y });
});
kn.displayName = Wi;
function Bi(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (ke(n, { select: t }), document.activeElement !== r) return;
}
function Yi(e) {
  const t = In(e), r = Xr(t, e), n = Xr(t.reverse(), e);
  return [r, n];
}
function In(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Xr(e, t) {
  for (const r of e)
    if (!Vi(r, { upTo: t })) return r;
}
function Vi(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function zi(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ke(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && zi(e) && t && e.select();
  }
}
var qr = Hi();
function Hi() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = Kr(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = Kr(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function Kr(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function Ui(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Le = globalThis != null && globalThis.document ? f.useLayoutEffect : () => {
}, Xi = f[" useId ".trim().toString()] || (() => {
}), qi = 0;
function Ki(e) {
  const [t, r] = f.useState(Xi());
  return Le(() => {
    e || r((n) => n ?? String(qi++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const Zi = ["top", "right", "bottom", "left"], Ie = Math.min, ve = Math.max, Ct = Math.round, pt = Math.floor, Se = (e) => ({
  x: e,
  y: e
}), Gi = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Ji = {
  start: "end",
  end: "start"
};
function ar(e, t, r) {
  return ve(e, Ie(t, r));
}
function Me(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function je(e) {
  return e.split("-")[0];
}
function et(e) {
  return e.split("-")[1];
}
function hr(e) {
  return e === "x" ? "y" : "x";
}
function mr(e) {
  return e === "y" ? "height" : "width";
}
const Qi = /* @__PURE__ */ new Set(["top", "bottom"]);
function Ee(e) {
  return Qi.has(je(e)) ? "y" : "x";
}
function gr(e) {
  return hr(Ee(e));
}
function ea(e, t, r) {
  r === void 0 && (r = !1);
  const n = et(e), o = gr(e), i = mr(o);
  let s = o === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = Rt(s)), [s, Rt(s)];
}
function ta(e) {
  const t = Rt(e);
  return [sr(e), t, sr(t)];
}
function sr(e) {
  return e.replace(/start|end/g, (t) => Ji[t]);
}
const Zr = ["left", "right"], Gr = ["right", "left"], ra = ["top", "bottom"], na = ["bottom", "top"];
function oa(e, t, r) {
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? Gr : Zr : t ? Zr : Gr;
    case "left":
    case "right":
      return t ? ra : na;
    default:
      return [];
  }
}
function ia(e, t, r, n) {
  const o = et(e);
  let i = oa(je(e), r === "start", n);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(sr)))), i;
}
function Rt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Gi[t]);
}
function aa(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Nn(e) {
  return typeof e != "number" ? aa(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Pt(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: o
  } = e;
  return {
    width: n,
    height: o,
    top: r,
    left: t,
    right: t + n,
    bottom: r + o,
    x: t,
    y: r
  };
}
function Jr(e, t, r) {
  let {
    reference: n,
    floating: o
  } = e;
  const i = Ee(t), s = gr(t), a = mr(s), c = je(t), l = i === "y", u = n.x + n.width / 2 - o.width / 2, d = n.y + n.height / 2 - o.height / 2, v = n[a] / 2 - o[a] / 2;
  let h;
  switch (c) {
    case "top":
      h = {
        x: u,
        y: n.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      h = {
        x: n.x + n.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: n.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: n.x,
        y: n.y
      };
  }
  switch (et(t)) {
    case "start":
      h[s] -= v * (r && l ? -1 : 1);
      break;
    case "end":
      h[s] += v * (r && l ? -1 : 1);
      break;
  }
  return h;
}
const sa = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = r, a = i.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let l = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = Jr(l, n, c), v = n, h = {}, y = 0;
  for (let m = 0; m < a.length; m++) {
    const {
      name: b,
      fn: w
    } = a[m], {
      x: E,
      y: R,
      data: C,
      reset: g
    } = await w({
      x: u,
      y: d,
      initialPlacement: n,
      placement: v,
      strategy: o,
      middlewareData: h,
      rects: l,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = E ?? u, d = R ?? d, h = {
      ...h,
      [b]: {
        ...h[b],
        ...C
      }
    }, g && y <= 50 && (y++, typeof g == "object" && (g.placement && (v = g.placement), g.rects && (l = g.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : g.rects), {
      x: u,
      y: d
    } = Jr(l, v, c)), m = -1);
  }
  return {
    x: u,
    y: d,
    placement: v,
    strategy: o,
    middlewareData: h
  };
};
async function at(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: v = !1,
    padding: h = 0
  } = Me(t, e), y = Nn(h), b = a[v ? d === "floating" ? "reference" : "floating" : d], w = Pt(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(b))) == null || r ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: c
  })), E = d === "floating" ? {
    x: n,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, R = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), C = await (i.isElement == null ? void 0 : i.isElement(R)) ? await (i.getScale == null ? void 0 : i.getScale(R)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, g = Pt(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: E,
    offsetParent: R,
    strategy: c
  }) : E);
  return {
    top: (w.top - g.top + y.top) / C.y,
    bottom: (g.bottom - w.bottom + y.bottom) / C.y,
    left: (w.left - g.left + y.left) / C.x,
    right: (g.right - w.right + y.right) / C.x
  };
}
const ca = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: o,
      rects: i,
      platform: s,
      elements: a,
      middlewareData: c
    } = t, {
      element: l,
      padding: u = 0
    } = Me(e, t) || {};
    if (l == null)
      return {};
    const d = Nn(u), v = {
      x: r,
      y: n
    }, h = gr(o), y = mr(h), m = await s.getDimensions(l), b = h === "y", w = b ? "top" : "left", E = b ? "bottom" : "right", R = b ? "clientHeight" : "clientWidth", C = i.reference[y] + i.reference[h] - v[h] - i.floating[y], g = v[h] - i.reference[h], D = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let _ = D ? D[R] : 0;
    (!_ || !await (s.isElement == null ? void 0 : s.isElement(D))) && (_ = a.floating[R] || i.floating[y]);
    const V = C / 2 - g / 2, L = _ / 2 - m[y] / 2 - 1, F = Ie(d[w], L), te = Ie(d[E], L), ne = F, K = _ - m[y] - te, z = _ / 2 - m[y] / 2 + V, oe = ar(ne, z, K), Z = !c.arrow && et(o) != null && z !== oe && i.reference[y] / 2 - (z < ne ? F : te) - m[y] / 2 < 0, G = Z ? z < ne ? z - ne : z - K : 0;
    return {
      [h]: v[h] + G,
      data: {
        [h]: oe,
        centerOffset: z - oe - G,
        ...Z && {
          alignmentOffset: G
        }
      },
      reset: Z
    };
  }
}), la = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: a,
        platform: c,
        elements: l
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: v,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: m = !0,
        ...b
      } = Me(e, t);
      if ((r = i.arrow) != null && r.alignmentOffset)
        return {};
      const w = je(o), E = Ee(a), R = je(a) === a, C = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), g = v || (R || !m ? [Rt(a)] : ta(a)), D = y !== "none";
      !v && D && g.push(...ia(a, m, y, C));
      const _ = [a, ...g], V = await at(t, b), L = [];
      let F = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (u && L.push(V[w]), d) {
        const z = ea(o, s, C);
        L.push(V[z[0]], V[z[1]]);
      }
      if (F = [...F, {
        placement: o,
        overflows: L
      }], !L.every((z) => z <= 0)) {
        var te, ne;
        const z = (((te = i.flip) == null ? void 0 : te.index) || 0) + 1, oe = _[z];
        if (oe && (!(d === "alignment" ? E !== Ee(oe) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        F.every((N) => Ee(N.placement) === E ? N.overflows[0] > 0 : !0)))
          return {
            data: {
              index: z,
              overflows: F
            },
            reset: {
              placement: oe
            }
          };
        let Z = (ne = F.filter((G) => G.overflows[0] <= 0).sort((G, N) => G.overflows[1] - N.overflows[1])[0]) == null ? void 0 : ne.placement;
        if (!Z)
          switch (h) {
            case "bestFit": {
              var K;
              const G = (K = F.filter((N) => {
                if (D) {
                  const ie = Ee(N.placement);
                  return ie === E || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ie === "y";
                }
                return !0;
              }).map((N) => [N.placement, N.overflows.filter((ie) => ie > 0).reduce((ie, x) => ie + x, 0)]).sort((N, ie) => N[1] - ie[1])[0]) == null ? void 0 : K[0];
              G && (Z = G);
              break;
            }
            case "initialPlacement":
              Z = a;
              break;
          }
        if (o !== Z)
          return {
            reset: {
              placement: Z
            }
          };
      }
      return {};
    }
  };
};
function Qr(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function en(e) {
  return Zi.some((t) => e[t] >= 0);
}
const ua = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...o
      } = Me(e, t);
      switch (n) {
        case "referenceHidden": {
          const i = await at(t, {
            ...o,
            elementContext: "reference"
          }), s = Qr(i, r.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: en(s)
            }
          };
        }
        case "escaped": {
          const i = await at(t, {
            ...o,
            altBoundary: !0
          }), s = Qr(i, r.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: en(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, $n = /* @__PURE__ */ new Set(["left", "top"]);
async function fa(e, t) {
  const {
    placement: r,
    platform: n,
    elements: o
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), s = je(r), a = et(r), c = Ee(r) === "y", l = $n.has(s) ? -1 : 1, u = i && c ? -1 : 1, d = Me(t, e);
  let {
    mainAxis: v,
    crossAxis: h,
    alignmentAxis: y
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof y == "number" && (h = a === "end" ? y * -1 : y), c ? {
    x: h * u,
    y: v * l
  } : {
    x: v * l,
    y: h * u
  };
}
const da = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: a
      } = t, c = await fa(t, e);
      return s === ((r = a.offset) == null ? void 0 : r.placement) && (n = a.arrow) != null && n.alignmentOffset ? {} : {
        x: o + c.x,
        y: i + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, pa = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (b) => {
            let {
              x: w,
              y: E
            } = b;
            return {
              x: w,
              y: E
            };
          }
        },
        ...c
      } = Me(e, t), l = {
        x: r,
        y: n
      }, u = await at(t, c), d = Ee(je(o)), v = hr(d);
      let h = l[v], y = l[d];
      if (i) {
        const b = v === "y" ? "top" : "left", w = v === "y" ? "bottom" : "right", E = h + u[b], R = h - u[w];
        h = ar(E, h, R);
      }
      if (s) {
        const b = d === "y" ? "top" : "left", w = d === "y" ? "bottom" : "right", E = y + u[b], R = y - u[w];
        y = ar(E, y, R);
      }
      const m = a.fn({
        ...t,
        [v]: h,
        [d]: y
      });
      return {
        ...m,
        data: {
          x: m.x - r,
          y: m.y - n,
          enabled: {
            [v]: i,
            [d]: s
          }
        }
      };
    }
  };
}, va = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = Me(e, t), u = {
        x: r,
        y: n
      }, d = Ee(o), v = hr(d);
      let h = u[v], y = u[d];
      const m = Me(a, t), b = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (c) {
        const R = v === "y" ? "height" : "width", C = i.reference[v] - i.floating[R] + b.mainAxis, g = i.reference[v] + i.reference[R] - b.mainAxis;
        h < C ? h = C : h > g && (h = g);
      }
      if (l) {
        var w, E;
        const R = v === "y" ? "width" : "height", C = $n.has(je(o)), g = i.reference[d] - i.floating[R] + (C && ((w = s.offset) == null ? void 0 : w[d]) || 0) + (C ? 0 : b.crossAxis), D = i.reference[d] + i.reference[R] + (C ? 0 : ((E = s.offset) == null ? void 0 : E[d]) || 0) - (C ? b.crossAxis : 0);
        y < g ? y = g : y > D && (y = D);
      }
      return {
        [v]: h,
        [d]: y
      };
    }
  };
}, ha = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: a
      } = t, {
        apply: c = () => {
        },
        ...l
      } = Me(e, t), u = await at(t, l), d = je(o), v = et(o), h = Ee(o) === "y", {
        width: y,
        height: m
      } = i.floating;
      let b, w;
      d === "top" || d === "bottom" ? (b = d, w = v === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (w = d, b = v === "end" ? "top" : "bottom");
      const E = m - u.top - u.bottom, R = y - u.left - u.right, C = Ie(m - u[b], E), g = Ie(y - u[w], R), D = !t.middlewareData.shift;
      let _ = C, V = g;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (V = R), (n = t.middlewareData.shift) != null && n.enabled.y && (_ = E), D && !v) {
        const F = ve(u.left, 0), te = ve(u.right, 0), ne = ve(u.top, 0), K = ve(u.bottom, 0);
        h ? V = y - 2 * (F !== 0 || te !== 0 ? F + te : ve(u.left, u.right)) : _ = m - 2 * (ne !== 0 || K !== 0 ? ne + K : ve(u.top, u.bottom));
      }
      await c({
        ...t,
        availableWidth: V,
        availableHeight: _
      });
      const L = await s.getDimensions(a.floating);
      return y !== L.width || m !== L.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function _t() {
  return typeof window < "u";
}
function tt(e) {
  return Fn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function me(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Re(e) {
  var t;
  return (t = (Fn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Fn(e) {
  return _t() ? e instanceof Node || e instanceof me(e).Node : !1;
}
function be(e) {
  return _t() ? e instanceof Element || e instanceof me(e).Element : !1;
}
function Ce(e) {
  return _t() ? e instanceof HTMLElement || e instanceof me(e).HTMLElement : !1;
}
function tn(e) {
  return !_t() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof me(e).ShadowRoot;
}
const ma = /* @__PURE__ */ new Set(["inline", "contents"]);
function ct(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: o
  } = we(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !ma.has(o);
}
const ga = /* @__PURE__ */ new Set(["table", "td", "th"]);
function ya(e) {
  return ga.has(tt(e));
}
const ba = [":popover-open", ":modal"];
function Dt(e) {
  return ba.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const wa = ["transform", "translate", "scale", "rotate", "perspective"], xa = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Ea = ["paint", "layout", "strict", "content"];
function yr(e) {
  const t = br(), r = be(e) ? we(e) : e;
  return wa.some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || xa.some((n) => (r.willChange || "").includes(n)) || Ea.some((n) => (r.contain || "").includes(n));
}
function Sa(e) {
  let t = Ne(e);
  for (; Ce(t) && !Ge(t); ) {
    if (yr(t))
      return t;
    if (Dt(t))
      return null;
    t = Ne(t);
  }
  return null;
}
function br() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Ca = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Ge(e) {
  return Ca.has(tt(e));
}
function we(e) {
  return me(e).getComputedStyle(e);
}
function Lt(e) {
  return be(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Ne(e) {
  if (tt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    tn(e) && e.host || // Fallback.
    Re(e)
  );
  return tn(t) ? t.host : t;
}
function Wn(e) {
  const t = Ne(e);
  return Ge(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ce(t) && ct(t) ? t : Wn(t);
}
function st(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const o = Wn(e), i = o === ((n = e.ownerDocument) == null ? void 0 : n.body), s = me(o);
  if (i) {
    const a = cr(s);
    return t.concat(s, s.visualViewport || [], ct(o) ? o : [], a && r ? st(a) : []);
  }
  return t.concat(o, st(o, [], r));
}
function cr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Bn(e) {
  const t = we(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = Ce(e), i = o ? e.offsetWidth : r, s = o ? e.offsetHeight : n, a = Ct(r) !== i || Ct(n) !== s;
  return a && (r = i, n = s), {
    width: r,
    height: n,
    $: a
  };
}
function wr(e) {
  return be(e) ? e : e.contextElement;
}
function Ke(e) {
  const t = wr(e);
  if (!Ce(t))
    return Se(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: i
  } = Bn(t);
  let s = (i ? Ct(r.width) : r.width) / n, a = (i ? Ct(r.height) : r.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const Ra = /* @__PURE__ */ Se(0);
function Yn(e) {
  const t = me(e);
  return !br() || !t.visualViewport ? Ra : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Pa(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== me(e) ? !1 : t;
}
function Be(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const o = e.getBoundingClientRect(), i = wr(e);
  let s = Se(1);
  t && (n ? be(n) && (s = Ke(n)) : s = Ke(e));
  const a = Pa(i, r, n) ? Yn(i) : Se(0);
  let c = (o.left + a.x) / s.x, l = (o.top + a.y) / s.y, u = o.width / s.x, d = o.height / s.y;
  if (i) {
    const v = me(i), h = n && be(n) ? me(n) : n;
    let y = v, m = cr(y);
    for (; m && n && h !== y; ) {
      const b = Ke(m), w = m.getBoundingClientRect(), E = we(m), R = w.left + (m.clientLeft + parseFloat(E.paddingLeft)) * b.x, C = w.top + (m.clientTop + parseFloat(E.paddingTop)) * b.y;
      c *= b.x, l *= b.y, u *= b.x, d *= b.y, c += R, l += C, y = me(m), m = cr(y);
    }
  }
  return Pt({
    width: u,
    height: d,
    x: c,
    y: l
  });
}
function Mt(e, t) {
  const r = Lt(e).scrollLeft;
  return t ? t.left + r : Be(Re(e)).left + r;
}
function Vn(e, t) {
  const r = e.getBoundingClientRect(), n = r.left + t.scrollLeft - Mt(e, r), o = r.top + t.scrollTop;
  return {
    x: n,
    y: o
  };
}
function Ta(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: o
  } = e;
  const i = o === "fixed", s = Re(n), a = t ? Dt(t.floating) : !1;
  if (n === s || a && i)
    return r;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Se(1);
  const u = Se(0), d = Ce(n);
  if ((d || !d && !i) && ((tt(n) !== "body" || ct(s)) && (c = Lt(n)), Ce(n))) {
    const h = Be(n);
    l = Ke(n), u.x = h.x + n.clientLeft, u.y = h.y + n.clientTop;
  }
  const v = s && !d && !i ? Vn(s, c) : Se(0);
  return {
    width: r.width * l.x,
    height: r.height * l.y,
    x: r.x * l.x - c.scrollLeft * l.x + u.x + v.x,
    y: r.y * l.y - c.scrollTop * l.y + u.y + v.y
  };
}
function Aa(e) {
  return Array.from(e.getClientRects());
}
function Oa(e) {
  const t = Re(e), r = Lt(e), n = e.ownerDocument.body, o = ve(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = ve(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let s = -r.scrollLeft + Mt(e);
  const a = -r.scrollTop;
  return we(n).direction === "rtl" && (s += ve(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: a
  };
}
const rn = 25;
function _a(e, t) {
  const r = me(e), n = Re(e), o = r.visualViewport;
  let i = n.clientWidth, s = n.clientHeight, a = 0, c = 0;
  if (o) {
    i = o.width, s = o.height;
    const u = br();
    (!u || u && t === "fixed") && (a = o.offsetLeft, c = o.offsetTop);
  }
  const l = Mt(n);
  if (l <= 0) {
    const u = n.ownerDocument, d = u.body, v = getComputedStyle(d), h = u.compatMode === "CSS1Compat" && parseFloat(v.marginLeft) + parseFloat(v.marginRight) || 0, y = Math.abs(n.clientWidth - d.clientWidth - h);
    y <= rn && (i -= y);
  } else l <= rn && (i += l);
  return {
    width: i,
    height: s,
    x: a,
    y: c
  };
}
const Da = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function La(e, t) {
  const r = Be(e, !0, t === "fixed"), n = r.top + e.clientTop, o = r.left + e.clientLeft, i = Ce(e) ? Ke(e) : Se(1), s = e.clientWidth * i.x, a = e.clientHeight * i.y, c = o * i.x, l = n * i.y;
  return {
    width: s,
    height: a,
    x: c,
    y: l
  };
}
function nn(e, t, r) {
  let n;
  if (t === "viewport")
    n = _a(e, r);
  else if (t === "document")
    n = Oa(Re(e));
  else if (be(t))
    n = La(t, r);
  else {
    const o = Yn(e);
    n = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Pt(n);
}
function zn(e, t) {
  const r = Ne(e);
  return r === t || !be(r) || Ge(r) ? !1 : we(r).position === "fixed" || zn(r, t);
}
function Ma(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = st(e, [], !1).filter((a) => be(a) && tt(a) !== "body"), o = null;
  const i = we(e).position === "fixed";
  let s = i ? Ne(e) : e;
  for (; be(s) && !Ge(s); ) {
    const a = we(s), c = yr(s);
    !c && a.position === "fixed" && (o = null), (i ? !c && !o : !c && a.position === "static" && !!o && Da.has(o.position) || ct(s) && !c && zn(e, s)) ? n = n.filter((u) => u !== s) : o = a, s = Ne(s);
  }
  return t.set(e, n), n;
}
function ja(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: o
  } = e;
  const s = [...r === "clippingAncestors" ? Dt(t) ? [] : Ma(t, this._c) : [].concat(r), n], a = s[0], c = s.reduce((l, u) => {
    const d = nn(t, u, o);
    return l.top = ve(d.top, l.top), l.right = Ie(d.right, l.right), l.bottom = Ie(d.bottom, l.bottom), l.left = ve(d.left, l.left), l;
  }, nn(t, a, o));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function ka(e) {
  const {
    width: t,
    height: r
  } = Bn(e);
  return {
    width: t,
    height: r
  };
}
function Ia(e, t, r) {
  const n = Ce(t), o = Re(t), i = r === "fixed", s = Be(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Se(0);
  function l() {
    c.x = Mt(o);
  }
  if (n || !n && !i)
    if ((tt(t) !== "body" || ct(o)) && (a = Lt(t)), n) {
      const h = Be(t, !0, i, t);
      c.x = h.x + t.clientLeft, c.y = h.y + t.clientTop;
    } else o && l();
  i && !n && o && l();
  const u = o && !n && !i ? Vn(o, a) : Se(0), d = s.left + a.scrollLeft - c.x - u.x, v = s.top + a.scrollTop - c.y - u.y;
  return {
    x: d,
    y: v,
    width: s.width,
    height: s.height
  };
}
function Ut(e) {
  return we(e).position === "static";
}
function on(e, t) {
  if (!Ce(e) || we(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return Re(e) === r && (r = r.ownerDocument.body), r;
}
function Hn(e, t) {
  const r = me(e);
  if (Dt(e))
    return r;
  if (!Ce(e)) {
    let o = Ne(e);
    for (; o && !Ge(o); ) {
      if (be(o) && !Ut(o))
        return o;
      o = Ne(o);
    }
    return r;
  }
  let n = on(e, t);
  for (; n && ya(n) && Ut(n); )
    n = on(n, t);
  return n && Ge(n) && Ut(n) && !yr(n) ? r : n || Sa(e) || r;
}
const Na = async function(e) {
  const t = this.getOffsetParent || Hn, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: Ia(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function $a(e) {
  return we(e).direction === "rtl";
}
const Fa = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ta,
  getDocumentElement: Re,
  getClippingRect: ja,
  getOffsetParent: Hn,
  getElementRects: Na,
  getClientRects: Aa,
  getDimensions: ka,
  getScale: Ke,
  isElement: be,
  isRTL: $a
};
function Un(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Wa(e, t) {
  let r = null, n;
  const o = Re(e);
  function i() {
    var a;
    clearTimeout(n), (a = r) == null || a.disconnect(), r = null;
  }
  function s(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), i();
    const l = e.getBoundingClientRect(), {
      left: u,
      top: d,
      width: v,
      height: h
    } = l;
    if (a || t(), !v || !h)
      return;
    const y = pt(d), m = pt(o.clientWidth - (u + v)), b = pt(o.clientHeight - (d + h)), w = pt(u), R = {
      rootMargin: -y + "px " + -m + "px " + -b + "px " + -w + "px",
      threshold: ve(0, Ie(1, c)) || 1
    };
    let C = !0;
    function g(D) {
      const _ = D[0].intersectionRatio;
      if (_ !== c) {
        if (!C)
          return s();
        _ ? s(!1, _) : n = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      _ === 1 && !Un(l, e.getBoundingClientRect()) && s(), C = !1;
    }
    try {
      r = new IntersectionObserver(g, {
        ...R,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(g, R);
    }
    r.observe(e);
  }
  return s(!0), i;
}
function Ba(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, l = wr(e), u = o || i ? [...l ? st(l) : [], ...st(t)] : [];
  u.forEach((w) => {
    o && w.addEventListener("scroll", r, {
      passive: !0
    }), i && w.addEventListener("resize", r);
  });
  const d = l && a ? Wa(l, r) : null;
  let v = -1, h = null;
  s && (h = new ResizeObserver((w) => {
    let [E] = w;
    E && E.target === l && h && (h.unobserve(t), cancelAnimationFrame(v), v = requestAnimationFrame(() => {
      var R;
      (R = h) == null || R.observe(t);
    })), r();
  }), l && !c && h.observe(l), h.observe(t));
  let y, m = c ? Be(e) : null;
  c && b();
  function b() {
    const w = Be(e);
    m && !Un(m, w) && r(), m = w, y = requestAnimationFrame(b);
  }
  return r(), () => {
    var w;
    u.forEach((E) => {
      o && E.removeEventListener("scroll", r), i && E.removeEventListener("resize", r);
    }), d == null || d(), (w = h) == null || w.disconnect(), h = null, c && cancelAnimationFrame(y);
  };
}
const Ya = da, Va = pa, za = la, Ha = ha, Ua = ua, an = ca, Xa = va, qa = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: Fa,
    ...r
  }, i = {
    ...o.platform,
    _c: n
  };
  return sa(e, t, {
    ...o,
    platform: i
  });
};
var Ka = typeof document < "u", Za = function() {
}, xt = Ka ? vi : Za;
function Tt(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!Tt(e[n], t[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), r = o.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const i = o[n];
      if (!(i === "_owner" && e.$$typeof) && !Tt(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Xn(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function sn(e, t) {
  const r = Xn(e);
  return Math.round(t * r) / r;
}
function Xt(e) {
  const t = f.useRef(e);
  return xt(() => {
    t.current = e;
  }), t;
}
function Ga(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: c,
    open: l
  } = e, [u, d] = f.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [v, h] = f.useState(n);
  Tt(v, n) || h(n);
  const [y, m] = f.useState(null), [b, w] = f.useState(null), E = f.useCallback((N) => {
    N !== D.current && (D.current = N, m(N));
  }, []), R = f.useCallback((N) => {
    N !== _.current && (_.current = N, w(N));
  }, []), C = i || y, g = s || b, D = f.useRef(null), _ = f.useRef(null), V = f.useRef(u), L = c != null, F = Xt(c), te = Xt(o), ne = Xt(l), K = f.useCallback(() => {
    if (!D.current || !_.current)
      return;
    const N = {
      placement: t,
      strategy: r,
      middleware: v
    };
    te.current && (N.platform = te.current), qa(D.current, _.current, N).then((ie) => {
      const x = {
        ...ie,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: ne.current !== !1
      };
      z.current && !Tt(V.current, x) && (V.current = x, Tn.flushSync(() => {
        d(x);
      }));
    });
  }, [v, t, r, te, ne]);
  xt(() => {
    l === !1 && V.current.isPositioned && (V.current.isPositioned = !1, d((N) => ({
      ...N,
      isPositioned: !1
    })));
  }, [l]);
  const z = f.useRef(!1);
  xt(() => (z.current = !0, () => {
    z.current = !1;
  }), []), xt(() => {
    if (C && (D.current = C), g && (_.current = g), C && g) {
      if (F.current)
        return F.current(C, g, K);
      K();
    }
  }, [C, g, K, F, L]);
  const oe = f.useMemo(() => ({
    reference: D,
    floating: _,
    setReference: E,
    setFloating: R
  }), [E, R]), Z = f.useMemo(() => ({
    reference: C,
    floating: g
  }), [C, g]), G = f.useMemo(() => {
    const N = {
      position: r,
      left: 0,
      top: 0
    };
    if (!Z.floating)
      return N;
    const ie = sn(Z.floating, u.x), x = sn(Z.floating, u.y);
    return a ? {
      ...N,
      transform: "translate(" + ie + "px, " + x + "px)",
      ...Xn(Z.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: ie,
      top: x
    };
  }, [r, a, Z.floating, u.x, u.y]);
  return f.useMemo(() => ({
    ...u,
    update: K,
    refs: oe,
    elements: Z,
    floatingStyles: G
  }), [u, K, oe, Z, G]);
}
const Ja = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: o
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? an({
        element: n.current,
        padding: o
      }).fn(r) : {} : n ? an({
        element: n,
        padding: o
      }).fn(r) : {};
    }
  };
}, Qa = (e, t) => ({
  ...Ya(e),
  options: [e, t]
}), es = (e, t) => ({
  ...Va(e),
  options: [e, t]
}), ts = (e, t) => ({
  ...Xa(e),
  options: [e, t]
}), rs = (e, t) => ({
  ...za(e),
  options: [e, t]
}), ns = (e, t) => ({
  ...Ha(e),
  options: [e, t]
}), os = (e, t) => ({
  ...Ua(e),
  options: [e, t]
}), is = (e, t) => ({
  ...Ja(e),
  options: [e, t]
});
var as = "Arrow", qn = f.forwardRef((e, t) => {
  const { children: r, width: n = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ P.jsx(
    pe.svg,
    {
      ...i,
      ref: t,
      width: n,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ P.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
qn.displayName = as;
var ss = qn;
function cs(e) {
  const [t, r] = f.useState(void 0);
  return Le(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const n = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, a;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          s = l.inlineSize, a = l.blockSize;
        } else
          s = e.offsetWidth, a = e.offsetHeight;
        r({ width: s, height: a });
      });
      return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [e]), t;
}
var xr = "Popper", [Kn, Zn] = vr(xr), [ls, Gn] = Kn(xr), Jn = (e) => {
  const { __scopePopper: t, children: r } = e, [n, o] = f.useState(null);
  return /* @__PURE__ */ P.jsx(ls, { scope: t, anchor: n, onAnchorChange: o, children: r });
};
Jn.displayName = xr;
var Qn = "PopperAnchor", eo = f.forwardRef(
  (e, t) => {
    const { __scopePopper: r, virtualRef: n, ...o } = e, i = Gn(Qn, r), s = f.useRef(null), a = de(t, s), c = f.useRef(null);
    return f.useEffect(() => {
      const l = c.current;
      c.current = (n == null ? void 0 : n.current) || s.current, l !== c.current && i.onAnchorChange(c.current);
    }), n ? null : /* @__PURE__ */ P.jsx(pe.div, { ...o, ref: a });
  }
);
eo.displayName = Qn;
var Er = "PopperContent", [us, fs] = Kn(Er), to = f.forwardRef(
  (e, t) => {
    var I, B, U, Y, ce, T;
    const {
      __scopePopper: r,
      side: n = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: a = 0,
      avoidCollisions: c = !0,
      collisionBoundary: l = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: v = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: y,
      ...m
    } = e, b = Gn(Er, r), [w, E] = f.useState(null), R = de(t, (le) => E(le)), [C, g] = f.useState(null), D = cs(C), _ = (D == null ? void 0 : D.width) ?? 0, V = (D == null ? void 0 : D.height) ?? 0, L = n + (i !== "center" ? "-" + i : ""), F = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, te = Array.isArray(l) ? l : [l], ne = te.length > 0, K = {
      padding: F,
      boundary: te.filter(ps),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: ne
    }, { refs: z, floatingStyles: oe, placement: Z, isPositioned: G, middlewareData: N } = Ga({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: L,
      whileElementsMounted: (...le) => Ba(...le, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        Qa({ mainAxis: o + V, alignmentAxis: s }),
        c && es({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? ts() : void 0,
          ...K
        }),
        c && rs({ ...K }),
        ns({
          ...K,
          apply: ({ elements: le, rects: Te, availableWidth: Ae, availableHeight: Ve }) => {
            const { width: ft, height: dt } = Te.reference, Oe = le.floating.style;
            Oe.setProperty("--radix-popper-available-width", `${Ae}px`), Oe.setProperty("--radix-popper-available-height", `${Ve}px`), Oe.setProperty("--radix-popper-anchor-width", `${ft}px`), Oe.setProperty("--radix-popper-anchor-height", `${dt}px`);
          }
        }),
        C && is({ element: C, padding: a }),
        vs({ arrowWidth: _, arrowHeight: V }),
        v && os({ strategy: "referenceHidden", ...K })
      ]
    }), [ie, x] = oo(Z), O = he(y);
    Le(() => {
      G && (O == null || O());
    }, [G, O]);
    const W = (I = N.arrow) == null ? void 0 : I.x, $ = (B = N.arrow) == null ? void 0 : B.y, j = ((U = N.arrow) == null ? void 0 : U.centerOffset) !== 0, [H, k] = f.useState();
    return Le(() => {
      w && k(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ P.jsx(
      "div",
      {
        ref: z.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...oe,
          transform: G ? oe.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: H,
          "--radix-popper-transform-origin": [
            (Y = N.transformOrigin) == null ? void 0 : Y.x,
            (ce = N.transformOrigin) == null ? void 0 : ce.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((T = N.hide) == null ? void 0 : T.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ P.jsx(
          us,
          {
            scope: r,
            placedSide: ie,
            onArrowChange: g,
            arrowX: W,
            arrowY: $,
            shouldHideArrow: j,
            children: /* @__PURE__ */ P.jsx(
              pe.div,
              {
                "data-side": ie,
                "data-align": x,
                ...m,
                ref: R,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: G ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
to.displayName = Er;
var ro = "PopperArrow", ds = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, no = f.forwardRef(function(t, r) {
  const { __scopePopper: n, ...o } = t, i = fs(ro, n), s = ds[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ P.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ P.jsx(
          ss,
          {
            ...o,
            ref: r,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
no.displayName = ro;
function ps(e) {
  return e !== null;
}
var vs = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var b, w, E;
    const { placement: r, rects: n, middlewareData: o } = t, s = ((b = o.arrow) == null ? void 0 : b.centerOffset) !== 0, a = s ? 0 : e.arrowWidth, c = s ? 0 : e.arrowHeight, [l, u] = oo(r), d = { start: "0%", center: "50%", end: "100%" }[u], v = (((w = o.arrow) == null ? void 0 : w.x) ?? 0) + a / 2, h = (((E = o.arrow) == null ? void 0 : E.y) ?? 0) + c / 2;
    let y = "", m = "";
    return l === "bottom" ? (y = s ? d : `${v}px`, m = `${-c}px`) : l === "top" ? (y = s ? d : `${v}px`, m = `${n.floating.height + c}px`) : l === "right" ? (y = `${-c}px`, m = s ? d : `${h}px`) : l === "left" && (y = `${n.floating.width + c}px`, m = s ? d : `${h}px`), { data: { x: y, y: m } };
  }
});
function oo(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
var hs = Jn, io = eo, ms = to, gs = no, ys = "Portal", ao = f.forwardRef((e, t) => {
  var a;
  const { container: r, ...n } = e, [o, i] = f.useState(!1);
  Le(() => i(!0), []);
  const s = r || o && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? yi.createPortal(/* @__PURE__ */ P.jsx(pe.div, { ...n, ref: t }), s) : null;
});
ao.displayName = ys;
function bs(e, t) {
  return f.useReducer((r, n) => t[r][n] ?? r, e);
}
var Ye = (e) => {
  const { present: t, children: r } = e, n = ws(t), o = typeof r == "function" ? r({ present: n.isPresent }) : f.Children.only(r), i = de(n.ref, xs(o));
  return typeof r == "function" || n.isPresent ? f.cloneElement(o, { ref: i }) : null;
};
Ye.displayName = "Presence";
function ws(e) {
  const [t, r] = f.useState(), n = f.useRef(null), o = f.useRef(e), i = f.useRef("none"), s = e ? "mounted" : "unmounted", [a, c] = bs(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return f.useEffect(() => {
    const l = vt(n.current);
    i.current = a === "mounted" ? l : "none";
  }, [a]), Le(() => {
    const l = n.current, u = o.current;
    if (u !== e) {
      const v = i.current, h = vt(l);
      e ? c("MOUNT") : h === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(u && v !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), Le(() => {
    if (t) {
      let l;
      const u = t.ownerDocument.defaultView ?? window, d = (h) => {
        const m = vt(n.current).includes(CSS.escape(h.animationName));
        if (h.target === t && m && (c("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, v = (h) => {
        h.target === t && (i.current = vt(n.current));
      };
      return t.addEventListener("animationstart", v), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(l), t.removeEventListener("animationstart", v), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: f.useCallback((l) => {
      n.current = l ? getComputedStyle(l) : null, r(l);
    }, [])
  };
}
function vt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function xs(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
// @__NO_SIDE_EFFECTS__
function Es(e) {
  const t = /* @__PURE__ */ Ss(e), r = f.forwardRef((n, o) => {
    const { children: i, ...s } = n, a = f.Children.toArray(i), c = a.find(Rs);
    if (c) {
      const l = c.props.children, u = a.map((d) => d === c ? f.Children.count(l) > 1 ? f.Children.only(null) : f.isValidElement(l) ? l.props.children : null : d);
      return /* @__PURE__ */ P.jsx(t, { ...s, ref: o, children: f.isValidElement(l) ? f.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ P.jsx(t, { ...s, ref: o, children: i });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function Ss(e) {
  const t = f.forwardRef((r, n) => {
    const { children: o, ...i } = r;
    if (f.isValidElement(o)) {
      const s = Ts(o), a = Ps(i, o.props);
      return o.type !== f.Fragment && (a.ref = n ? pr(n, s) : s), f.cloneElement(o, a);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Cs = Symbol("radix.slottable");
function Rs(e) {
  return f.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Cs;
}
function Ps(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? o && i ? r[n] = (...a) => {
      const c = i(...a);
      return o(...a), c;
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...i } : n === "className" && (r[n] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Ts(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var As = f[" useInsertionEffect ".trim().toString()] || Le;
function Os({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  },
  caller: n
}) {
  const [o, i, s] = _s({
    defaultProp: t,
    onChange: r
  }), a = e !== void 0, c = a ? e : o;
  {
    const u = f.useRef(e !== void 0);
    f.useEffect(() => {
      const d = u.current;
      d !== a && console.warn(
        `${n} is changing from ${d ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = a;
    }, [a, n]);
  }
  const l = f.useCallback(
    (u) => {
      var d;
      if (a) {
        const v = Ds(u) ? u(e) : u;
        v !== e && ((d = s.current) == null || d.call(s, v));
      } else
        i(u);
    },
    [a, e, i, s]
  );
  return [c, l];
}
function _s({
  defaultProp: e,
  onChange: t
}) {
  const [r, n] = f.useState(e), o = f.useRef(r), i = f.useRef(t);
  return As(() => {
    i.current = t;
  }, [t]), f.useEffect(() => {
    var s;
    o.current !== r && ((s = i.current) == null || s.call(i, r), o.current = r);
  }, [r, o]), [r, n, i];
}
function Ds(e) {
  return typeof e == "function";
}
var Ls = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Ue = /* @__PURE__ */ new WeakMap(), ht = /* @__PURE__ */ new WeakMap(), mt = {}, qt = 0, so = function(e) {
  return e && (e.host || so(e.parentNode));
}, Ms = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = so(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, js = function(e, t, r, n) {
  var o = Ms(t, Array.isArray(e) ? e : [e]);
  mt[r] || (mt[r] = /* @__PURE__ */ new WeakMap());
  var i = mt[r], s = [], a = /* @__PURE__ */ new Set(), c = new Set(o), l = function(d) {
    !d || a.has(d) || (a.add(d), l(d.parentNode));
  };
  o.forEach(l);
  var u = function(d) {
    !d || c.has(d) || Array.prototype.forEach.call(d.children, function(v) {
      if (a.has(v))
        u(v);
      else
        try {
          var h = v.getAttribute(n), y = h !== null && h !== "false", m = (Ue.get(v) || 0) + 1, b = (i.get(v) || 0) + 1;
          Ue.set(v, m), i.set(v, b), s.push(v), m === 1 && y && ht.set(v, !0), b === 1 && v.setAttribute(r, "true"), y || v.setAttribute(n, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", v, w);
        }
    });
  };
  return u(t), a.clear(), qt++, function() {
    s.forEach(function(d) {
      var v = Ue.get(d) - 1, h = i.get(d) - 1;
      Ue.set(d, v), i.set(d, h), v || (ht.has(d) || d.removeAttribute(n), ht.delete(d)), h || d.removeAttribute(r);
    }), qt--, qt || (Ue = /* @__PURE__ */ new WeakMap(), Ue = /* @__PURE__ */ new WeakMap(), ht = /* @__PURE__ */ new WeakMap(), mt = {});
  };
}, ks = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), o = Ls(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live], script"))), js(n, o, r, "aria-hidden")) : function() {
    return null;
  };
}, xe = function() {
  return xe = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, xe.apply(this, arguments);
};
function co(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function Is(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, o = t.length, i; n < o; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Et = "right-scroll-bar-position", St = "width-before-scroll-bar", Ns = "with-scroll-bars-hidden", $s = "--removed-body-scroll-bar-size";
function Kt(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Fs(e, t) {
  var r = We(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var o = r.value;
          o !== n && (r.value = n, r.callback(n, o));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var Ws = typeof window < "u" ? f.useLayoutEffect : f.useEffect, cn = /* @__PURE__ */ new WeakMap();
function Bs(e, t) {
  var r = Fs(null, function(n) {
    return e.forEach(function(o) {
      return Kt(o, n);
    });
  });
  return Ws(function() {
    var n = cn.get(r);
    if (n) {
      var o = new Set(n), i = new Set(e), s = r.current;
      o.forEach(function(a) {
        i.has(a) || Kt(a, null);
      }), i.forEach(function(a) {
        o.has(a) || Kt(a, s);
      });
    }
    cn.set(r, e);
  }, [e]), r;
}
function Ys(e) {
  return e;
}
function Vs(e, t) {
  t === void 0 && (t = Ys);
  var r = [], n = !1, o = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, n);
      return r.push(s), function() {
        r = r.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; r.length; ) {
        var s = r;
        r = [], s.forEach(i);
      }
      r = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var s = [];
      if (r.length) {
        var a = r;
        r = [], a.forEach(i), s = r;
      }
      var c = function() {
        var u = s;
        s = [], u.forEach(i);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), r = {
        push: function(u) {
          s.push(u), l();
        },
        filter: function(u) {
          return s = s.filter(u), r;
        }
      };
    }
  };
  return o;
}
function zs(e) {
  e === void 0 && (e = {});
  var t = Vs(null);
  return t.options = xe({ async: !0, ssr: !1 }, e), t;
}
var lo = function(e) {
  var t = e.sideCar, r = co(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return f.createElement(n, xe({}, r));
};
lo.isSideCarExport = !0;
function Hs(e, t) {
  return e.useMedium(t), lo;
}
var uo = zs(), Zt = function() {
}, jt = f.forwardRef(function(e, t) {
  var r = f.useRef(null), n = f.useState({
    onScrollCapture: Zt,
    onWheelCapture: Zt,
    onTouchMoveCapture: Zt
  }), o = n[0], i = n[1], s = e.forwardProps, a = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, v = e.sideCar, h = e.noRelative, y = e.noIsolation, m = e.inert, b = e.allowPinchZoom, w = e.as, E = w === void 0 ? "div" : w, R = e.gapMode, C = co(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), g = v, D = Bs([r, t]), _ = xe(xe({}, C), o);
  return f.createElement(
    f.Fragment,
    null,
    u && f.createElement(g, { sideCar: uo, removeScrollBar: l, shards: d, noRelative: h, noIsolation: y, inert: m, setCallbacks: i, allowPinchZoom: !!b, lockRef: r, gapMode: R }),
    s ? f.cloneElement(f.Children.only(a), xe(xe({}, _), { ref: D })) : f.createElement(E, xe({}, _, { className: c, ref: D }), a)
  );
});
jt.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
jt.classNames = {
  fullWidth: St,
  zeroRight: Et
};
var Us = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Xs() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Us();
  return t && e.setAttribute("nonce", t), e;
}
function qs(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Ks(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Zs = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = Xs()) && (qs(t, r), Ks(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Gs = function() {
  var e = Zs();
  return function(t, r) {
    f.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, fo = function() {
  var e = Gs(), t = function(r) {
    var n = r.styles, o = r.dynamic;
    return e(n, o), null;
  };
  return t;
}, Js = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Gt = function(e) {
  return parseInt(e || "", 10) || 0;
}, Qs = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Gt(r), Gt(n), Gt(o)];
}, ec = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Js;
  var t = Qs(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, tc = fo(), Ze = "data-scroll-locked", rc = function(e, t, r, n) {
  var o = e.left, i = e.top, s = e.right, a = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(Ns, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(a, "px ").concat(n, `;
  }
  body[`).concat(Ze, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(a, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Et, ` {
    right: `).concat(a, "px ").concat(n, `;
  }
  
  .`).concat(St, ` {
    margin-right: `).concat(a, "px ").concat(n, `;
  }
  
  .`).concat(Et, " .").concat(Et, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(St, " .").concat(St, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(Ze, `] {
    `).concat($s, ": ").concat(a, `px;
  }
`);
}, ln = function() {
  var e = parseInt(document.body.getAttribute(Ze) || "0", 10);
  return isFinite(e) ? e : 0;
}, nc = function() {
  f.useEffect(function() {
    return document.body.setAttribute(Ze, (ln() + 1).toString()), function() {
      var e = ln() - 1;
      e <= 0 ? document.body.removeAttribute(Ze) : document.body.setAttribute(Ze, e.toString());
    };
  }, []);
}, oc = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, o = n === void 0 ? "margin" : n;
  nc();
  var i = f.useMemo(function() {
    return ec(o);
  }, [o]);
  return f.createElement(tc, { styles: rc(i, !t, o, r ? "" : "!important") });
}, lr = !1;
if (typeof window < "u")
  try {
    var gt = Object.defineProperty({}, "passive", {
      get: function() {
        return lr = !0, !0;
      }
    });
    window.addEventListener("test", gt, gt), window.removeEventListener("test", gt, gt);
  } catch {
    lr = !1;
  }
var Xe = lr ? { passive: !1 } : !1, ic = function(e) {
  return e.tagName === "TEXTAREA";
}, po = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !ic(e) && r[t] === "visible")
  );
}, ac = function(e) {
  return po(e, "overflowY");
}, sc = function(e) {
  return po(e, "overflowX");
}, un = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = vo(e, n);
    if (o) {
      var i = ho(e, n), s = i[1], a = i[2];
      if (s > a)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, cc = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, lc = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, vo = function(e, t) {
  return e === "v" ? ac(t) : sc(t);
}, ho = function(e, t) {
  return e === "v" ? cc(t) : lc(t);
}, uc = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, fc = function(e, t, r, n, o) {
  var i = uc(e, window.getComputedStyle(t).direction), s = i * n, a = r.target, c = t.contains(a), l = !1, u = s > 0, d = 0, v = 0;
  do {
    if (!a)
      break;
    var h = ho(e, a), y = h[0], m = h[1], b = h[2], w = m - b - i * y;
    (y || w) && vo(e, a) && (d += w, v += y);
    var E = a.parentNode;
    a = E && E.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? E.host : E;
  } while (
    // portaled content
    !c && a !== document.body || // self content
    c && (t.contains(a) || t === a)
  );
  return (u && (Math.abs(d) < 1 || !o) || !u && (Math.abs(v) < 1 || !o)) && (l = !0), l;
}, yt = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, fn = function(e) {
  return [e.deltaX, e.deltaY];
}, dn = function(e) {
  return e && "current" in e ? e.current : e;
}, dc = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, pc = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, vc = 0, qe = [];
function hc(e) {
  var t = f.useRef([]), r = f.useRef([0, 0]), n = f.useRef(), o = f.useState(vc++)[0], i = f.useState(fo)[0], s = f.useRef(e);
  f.useEffect(function() {
    s.current = e;
  }, [e]), f.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var m = Is([e.lockRef.current], (e.shards || []).map(dn), !0).filter(Boolean);
      return m.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), m.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = f.useCallback(function(m, b) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !s.current.allowPinchZoom;
    var w = yt(m), E = r.current, R = "deltaX" in m ? m.deltaX : E[0] - w[0], C = "deltaY" in m ? m.deltaY : E[1] - w[1], g, D = m.target, _ = Math.abs(R) > Math.abs(C) ? "h" : "v";
    if ("touches" in m && _ === "h" && D.type === "range")
      return !1;
    var V = un(_, D);
    if (!V)
      return !0;
    if (V ? g = _ : (g = _ === "v" ? "h" : "v", V = un(_, D)), !V)
      return !1;
    if (!n.current && "changedTouches" in m && (R || C) && (n.current = g), !g)
      return !0;
    var L = n.current || g;
    return fc(L, b, m, L === "h" ? R : C, !0);
  }, []), c = f.useCallback(function(m) {
    var b = m;
    if (!(!qe.length || qe[qe.length - 1] !== i)) {
      var w = "deltaY" in b ? fn(b) : yt(b), E = t.current.filter(function(g) {
        return g.name === b.type && (g.target === b.target || b.target === g.shadowParent) && dc(g.delta, w);
      })[0];
      if (E && E.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!E) {
        var R = (s.current.shards || []).map(dn).filter(Boolean).filter(function(g) {
          return g.contains(b.target);
        }), C = R.length > 0 ? a(b, R[0]) : !s.current.noIsolation;
        C && b.cancelable && b.preventDefault();
      }
    }
  }, []), l = f.useCallback(function(m, b, w, E) {
    var R = { name: m, delta: b, target: w, should: E, shadowParent: mc(w) };
    t.current.push(R), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== R;
      });
    }, 1);
  }, []), u = f.useCallback(function(m) {
    r.current = yt(m), n.current = void 0;
  }, []), d = f.useCallback(function(m) {
    l(m.type, fn(m), m.target, a(m, e.lockRef.current));
  }, []), v = f.useCallback(function(m) {
    l(m.type, yt(m), m.target, a(m, e.lockRef.current));
  }, []);
  f.useEffect(function() {
    return qe.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: v
    }), document.addEventListener("wheel", c, Xe), document.addEventListener("touchmove", c, Xe), document.addEventListener("touchstart", u, Xe), function() {
      qe = qe.filter(function(m) {
        return m !== i;
      }), document.removeEventListener("wheel", c, Xe), document.removeEventListener("touchmove", c, Xe), document.removeEventListener("touchstart", u, Xe);
    };
  }, []);
  var h = e.removeScrollBar, y = e.inert;
  return f.createElement(
    f.Fragment,
    null,
    y ? f.createElement(i, { styles: pc(o) }) : null,
    h ? f.createElement(oc, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function mc(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const gc = Hs(uo, hc);
var mo = f.forwardRef(function(e, t) {
  return f.createElement(jt, xe({}, e, { ref: t, sideCar: gc }));
});
mo.classNames = jt.classNames;
var kt = "Popover", [go, Sl] = vr(kt, [
  Zn
]), lt = Zn(), [yc, Fe] = go(kt), yo = (e) => {
  const {
    __scopePopover: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !1
  } = e, a = lt(t), c = f.useRef(null), [l, u] = f.useState(!1), [d, v] = Os({
    prop: n,
    defaultProp: o ?? !1,
    onChange: i,
    caller: kt
  });
  return /* @__PURE__ */ P.jsx(hs, { ...a, children: /* @__PURE__ */ P.jsx(
    yc,
    {
      scope: t,
      contentId: Ki(),
      triggerRef: c,
      open: d,
      onOpenChange: v,
      onOpenToggle: f.useCallback(() => v((h) => !h), [v]),
      hasCustomAnchor: l,
      onCustomAnchorAdd: f.useCallback(() => u(!0), []),
      onCustomAnchorRemove: f.useCallback(() => u(!1), []),
      modal: s,
      children: r
    }
  ) });
};
yo.displayName = kt;
var bo = "PopoverAnchor", bc = f.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Fe(bo, r), i = lt(r), { onCustomAnchorAdd: s, onCustomAnchorRemove: a } = o;
    return f.useEffect(() => (s(), () => a()), [s, a]), /* @__PURE__ */ P.jsx(io, { ...i, ...n, ref: t });
  }
);
bc.displayName = bo;
var wo = "PopoverTrigger", xo = f.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Fe(wo, r), i = lt(r), s = de(t, o.triggerRef), a = /* @__PURE__ */ P.jsx(
      pe.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Po(o.open),
        ...n,
        ref: s,
        onClick: fe(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? a : /* @__PURE__ */ P.jsx(io, { asChild: !0, ...i, children: a });
  }
);
xo.displayName = wo;
var Sr = "PopoverPortal", [wc, xc] = go(Sr, {
  forceMount: void 0
}), Eo = (e) => {
  const { __scopePopover: t, forceMount: r, children: n, container: o } = e, i = Fe(Sr, t);
  return /* @__PURE__ */ P.jsx(wc, { scope: t, forceMount: r, children: /* @__PURE__ */ P.jsx(Ye, { present: r || i.open, children: /* @__PURE__ */ P.jsx(ao, { asChild: !0, container: o, children: n }) }) });
};
Eo.displayName = Sr;
var Je = "PopoverContent", So = f.forwardRef(
  (e, t) => {
    const r = xc(Je, e.__scopePopover), { forceMount: n = r.forceMount, ...o } = e, i = Fe(Je, e.__scopePopover);
    return /* @__PURE__ */ P.jsx(Ye, { present: n || i.open, children: i.modal ? /* @__PURE__ */ P.jsx(Sc, { ...o, ref: t }) : /* @__PURE__ */ P.jsx(Cc, { ...o, ref: t }) });
  }
);
So.displayName = Je;
var Ec = /* @__PURE__ */ Es("PopoverContent.RemoveScroll"), Sc = f.forwardRef(
  (e, t) => {
    const r = Fe(Je, e.__scopePopover), n = f.useRef(null), o = de(t, n), i = f.useRef(!1);
    return f.useEffect(() => {
      const s = n.current;
      if (s) return ks(s);
    }, []), /* @__PURE__ */ P.jsx(mo, { as: Ec, allowPinchZoom: !0, children: /* @__PURE__ */ P.jsx(
      Co,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: fe(e.onCloseAutoFocus, (s) => {
          var a;
          s.preventDefault(), i.current || (a = r.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: fe(
          e.onPointerDownOutside,
          (s) => {
            const a = s.detail.originalEvent, c = a.button === 0 && a.ctrlKey === !0, l = a.button === 2 || c;
            i.current = l;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: fe(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Cc = f.forwardRef(
  (e, t) => {
    const r = Fe(Je, e.__scopePopover), n = f.useRef(!1), o = f.useRef(!1);
    return /* @__PURE__ */ P.jsx(
      Co,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, a;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (n.current || (a = r.triggerRef.current) == null || a.focus(), i.preventDefault()), n.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var c, l;
          (c = e.onInteractOutside) == null || c.call(e, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((l = r.triggerRef.current) == null ? void 0 : l.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), Co = f.forwardRef(
  (e, t) => {
    const {
      __scopePopover: r,
      trapFocus: n,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: a,
      onPointerDownOutside: c,
      onFocusOutside: l,
      onInteractOutside: u,
      ...d
    } = e, v = Fe(Je, r), h = lt(r);
    return Fi(), /* @__PURE__ */ P.jsx(
      kn,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: o,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ P.jsx(
          Mn,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: u,
            onEscapeKeyDown: a,
            onPointerDownOutside: c,
            onFocusOutside: l,
            onDismiss: () => v.onOpenChange(!1),
            children: /* @__PURE__ */ P.jsx(
              ms,
              {
                "data-state": Po(v.open),
                role: "dialog",
                id: v.contentId,
                ...h,
                ...d,
                ref: t,
                style: {
                  ...d.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Ro = "PopoverClose", Rc = f.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Fe(Ro, r);
    return /* @__PURE__ */ P.jsx(
      pe.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: fe(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Rc.displayName = Ro;
var Pc = "PopoverArrow", Tc = f.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = lt(r);
    return /* @__PURE__ */ P.jsx(gs, { ...o, ...n, ref: t });
  }
);
Tc.displayName = Pc;
function Po(e) {
  return e ? "open" : "closed";
}
var Ac = yo, Oc = xo, _c = Eo, Dc = So;
function Lc(e) {
  const [t, r] = We(
    null
  ), [n, o] = We(1e3);
  return fr(() => {
    if (!e.current) return;
    let i = e.current.parentElement ?? document.body;
    r(document.body);
    const s = window.getComputedStyle(i).zIndex;
    o(s !== "auto" ? parseInt(s, 10) + 1 : 1e3);
  }, [e]), { portalContainer: t, zIndex: n };
}
const Mc = ["small", "medium"], jc = ["primary", "secondary"], kc = ["brand", "neutral"];
var ur = { exports: {} }, bt = { exports: {} }, Q = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pn;
function Ic() {
  if (pn) return Q;
  pn = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function R(g) {
    if (typeof g == "object" && g !== null) {
      var D = g.$$typeof;
      switch (D) {
        case t:
          switch (g = g.type, g) {
            case c:
            case l:
            case n:
            case i:
            case o:
            case d:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case a:
                case u:
                case y:
                case h:
                case s:
                  return g;
                default:
                  return D;
              }
          }
        case r:
          return D;
      }
    }
  }
  function C(g) {
    return R(g) === l;
  }
  return Q.AsyncMode = c, Q.ConcurrentMode = l, Q.ContextConsumer = a, Q.ContextProvider = s, Q.Element = t, Q.ForwardRef = u, Q.Fragment = n, Q.Lazy = y, Q.Memo = h, Q.Portal = r, Q.Profiler = i, Q.StrictMode = o, Q.Suspense = d, Q.isAsyncMode = function(g) {
    return C(g) || R(g) === c;
  }, Q.isConcurrentMode = C, Q.isContextConsumer = function(g) {
    return R(g) === a;
  }, Q.isContextProvider = function(g) {
    return R(g) === s;
  }, Q.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === t;
  }, Q.isForwardRef = function(g) {
    return R(g) === u;
  }, Q.isFragment = function(g) {
    return R(g) === n;
  }, Q.isLazy = function(g) {
    return R(g) === y;
  }, Q.isMemo = function(g) {
    return R(g) === h;
  }, Q.isPortal = function(g) {
    return R(g) === r;
  }, Q.isProfiler = function(g) {
    return R(g) === i;
  }, Q.isStrictMode = function(g) {
    return R(g) === o;
  }, Q.isSuspense = function(g) {
    return R(g) === d;
  }, Q.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === l || g === i || g === o || g === d || g === v || typeof g == "object" && g !== null && (g.$$typeof === y || g.$$typeof === h || g.$$typeof === s || g.$$typeof === a || g.$$typeof === u || g.$$typeof === b || g.$$typeof === w || g.$$typeof === E || g.$$typeof === m);
  }, Q.typeOf = R, Q;
}
var ee = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vn;
function Nc() {
  return vn || (vn = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function R(T) {
      return typeof T == "string" || typeof T == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      T === n || T === l || T === i || T === o || T === d || T === v || typeof T == "object" && T !== null && (T.$$typeof === y || T.$$typeof === h || T.$$typeof === s || T.$$typeof === a || T.$$typeof === u || T.$$typeof === b || T.$$typeof === w || T.$$typeof === E || T.$$typeof === m);
    }
    function C(T) {
      if (typeof T == "object" && T !== null) {
        var le = T.$$typeof;
        switch (le) {
          case t:
            var Te = T.type;
            switch (Te) {
              case c:
              case l:
              case n:
              case i:
              case o:
              case d:
                return Te;
              default:
                var Ae = Te && Te.$$typeof;
                switch (Ae) {
                  case a:
                  case u:
                  case y:
                  case h:
                  case s:
                    return Ae;
                  default:
                    return le;
                }
            }
          case r:
            return le;
        }
      }
    }
    var g = c, D = l, _ = a, V = s, L = t, F = u, te = n, ne = y, K = h, z = r, oe = i, Z = o, G = d, N = !1;
    function ie(T) {
      return N || (N = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), x(T) || C(T) === c;
    }
    function x(T) {
      return C(T) === l;
    }
    function O(T) {
      return C(T) === a;
    }
    function W(T) {
      return C(T) === s;
    }
    function $(T) {
      return typeof T == "object" && T !== null && T.$$typeof === t;
    }
    function j(T) {
      return C(T) === u;
    }
    function H(T) {
      return C(T) === n;
    }
    function k(T) {
      return C(T) === y;
    }
    function I(T) {
      return C(T) === h;
    }
    function B(T) {
      return C(T) === r;
    }
    function U(T) {
      return C(T) === i;
    }
    function Y(T) {
      return C(T) === o;
    }
    function ce(T) {
      return C(T) === d;
    }
    ee.AsyncMode = g, ee.ConcurrentMode = D, ee.ContextConsumer = _, ee.ContextProvider = V, ee.Element = L, ee.ForwardRef = F, ee.Fragment = te, ee.Lazy = ne, ee.Memo = K, ee.Portal = z, ee.Profiler = oe, ee.StrictMode = Z, ee.Suspense = G, ee.isAsyncMode = ie, ee.isConcurrentMode = x, ee.isContextConsumer = O, ee.isContextProvider = W, ee.isElement = $, ee.isForwardRef = j, ee.isFragment = H, ee.isLazy = k, ee.isMemo = I, ee.isPortal = B, ee.isProfiler = U, ee.isStrictMode = Y, ee.isSuspense = ce, ee.isValidElementType = R, ee.typeOf = C;
  }()), ee;
}
var hn;
function To() {
  return hn || (hn = 1, process.env.NODE_ENV === "production" ? bt.exports = Ic() : bt.exports = Nc()), bt.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Jt, mn;
function $c() {
  if (mn) return Jt;
  mn = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var c = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Jt = o() ? Object.assign : function(i, s) {
    for (var a, c = n(i), l, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var d in a)
        t.call(a, d) && (c[d] = a[d]);
      if (e) {
        l = e(a);
        for (var v = 0; v < l.length; v++)
          r.call(a, l[v]) && (c[l[v]] = a[l[v]]);
      }
    }
    return c;
  }, Jt;
}
var Qt, gn;
function Cr() {
  if (gn) return Qt;
  gn = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Qt = e, Qt;
}
var er, yn;
function Ao() {
  return yn || (yn = 1, er = Function.call.bind(Object.prototype.hasOwnProperty)), er;
}
var tr, bn;
function Fc() {
  if (bn) return tr;
  bn = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Cr(), r = {}, n = Ao();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(i, s, a, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (n(i, u)) {
          var d;
          try {
            if (typeof i[u] != "function") {
              var v = Error(
                (c || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw v.name = "Invariant Violation", v;
            }
            d = i[u](s, u, c, a, null, t);
          } catch (y) {
            d = y;
          }
          if (d && !(d instanceof Error) && e(
            (c || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in r)) {
            r[d.message] = !0;
            var h = l ? l() : "";
            e(
              "Failed " + a + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, tr = o, tr;
}
var rr, wn;
function Wc() {
  if (wn) return rr;
  wn = 1;
  var e = To(), t = $c(), r = Cr(), n = Ao(), o = Fc(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(a) {
    var c = "Warning: " + a;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return rr = function(a, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(x) {
      var O = x && (l && x[l] || x[u]);
      if (typeof O == "function")
        return O;
    }
    var v = "<<anonymous>>", h = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: E(),
      arrayOf: R,
      element: C(),
      elementType: g(),
      instanceOf: D,
      node: F(),
      objectOf: V,
      oneOf: _,
      oneOfType: L,
      shape: ne,
      exact: K
    };
    function y(x, O) {
      return x === O ? x !== 0 || 1 / x === 1 / O : x !== x && O !== O;
    }
    function m(x, O) {
      this.message = x, this.data = O && typeof O == "object" ? O : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function b(x) {
      if (process.env.NODE_ENV !== "production")
        var O = {}, W = 0;
      function $(H, k, I, B, U, Y, ce) {
        if (B = B || v, Y = Y || I, ce !== r) {
          if (c) {
            var T = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw T.name = "Invariant Violation", T;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var le = B + ":" + I;
            !O[le] && // Avoid spamming the console because they are often not actionable except for lib authors
            W < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + Y + "` prop on `" + B + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), O[le] = !0, W++);
          }
        }
        return k[I] == null ? H ? k[I] === null ? new m("The " + U + " `" + Y + "` is marked as required " + ("in `" + B + "`, but its value is `null`.")) : new m("The " + U + " `" + Y + "` is marked as required in " + ("`" + B + "`, but its value is `undefined`.")) : null : x(k, I, B, U, Y);
      }
      var j = $.bind(null, !1);
      return j.isRequired = $.bind(null, !0), j;
    }
    function w(x) {
      function O(W, $, j, H, k, I) {
        var B = W[$], U = Z(B);
        if (U !== x) {
          var Y = G(B);
          return new m(
            "Invalid " + H + " `" + k + "` of type " + ("`" + Y + "` supplied to `" + j + "`, expected ") + ("`" + x + "`."),
            { expectedType: x }
          );
        }
        return null;
      }
      return b(O);
    }
    function E() {
      return b(s);
    }
    function R(x) {
      function O(W, $, j, H, k) {
        if (typeof x != "function")
          return new m("Property `" + k + "` of component `" + j + "` has invalid PropType notation inside arrayOf.");
        var I = W[$];
        if (!Array.isArray(I)) {
          var B = Z(I);
          return new m("Invalid " + H + " `" + k + "` of type " + ("`" + B + "` supplied to `" + j + "`, expected an array."));
        }
        for (var U = 0; U < I.length; U++) {
          var Y = x(I, U, j, H, k + "[" + U + "]", r);
          if (Y instanceof Error)
            return Y;
        }
        return null;
      }
      return b(O);
    }
    function C() {
      function x(O, W, $, j, H) {
        var k = O[W];
        if (!a(k)) {
          var I = Z(k);
          return new m("Invalid " + j + " `" + H + "` of type " + ("`" + I + "` supplied to `" + $ + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(x);
    }
    function g() {
      function x(O, W, $, j, H) {
        var k = O[W];
        if (!e.isValidElementType(k)) {
          var I = Z(k);
          return new m("Invalid " + j + " `" + H + "` of type " + ("`" + I + "` supplied to `" + $ + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(x);
    }
    function D(x) {
      function O(W, $, j, H, k) {
        if (!(W[$] instanceof x)) {
          var I = x.name || v, B = ie(W[$]);
          return new m("Invalid " + H + " `" + k + "` of type " + ("`" + B + "` supplied to `" + j + "`, expected ") + ("instance of `" + I + "`."));
        }
        return null;
      }
      return b(O);
    }
    function _(x) {
      if (!Array.isArray(x))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function O(W, $, j, H, k) {
        for (var I = W[$], B = 0; B < x.length; B++)
          if (y(I, x[B]))
            return null;
        var U = JSON.stringify(x, function(ce, T) {
          var le = G(T);
          return le === "symbol" ? String(T) : T;
        });
        return new m("Invalid " + H + " `" + k + "` of value `" + String(I) + "` " + ("supplied to `" + j + "`, expected one of " + U + "."));
      }
      return b(O);
    }
    function V(x) {
      function O(W, $, j, H, k) {
        if (typeof x != "function")
          return new m("Property `" + k + "` of component `" + j + "` has invalid PropType notation inside objectOf.");
        var I = W[$], B = Z(I);
        if (B !== "object")
          return new m("Invalid " + H + " `" + k + "` of type " + ("`" + B + "` supplied to `" + j + "`, expected an object."));
        for (var U in I)
          if (n(I, U)) {
            var Y = x(I, U, j, H, k + "." + U, r);
            if (Y instanceof Error)
              return Y;
          }
        return null;
      }
      return b(O);
    }
    function L(x) {
      if (!Array.isArray(x))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var O = 0; O < x.length; O++) {
        var W = x[O];
        if (typeof W != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + N(W) + " at index " + O + "."
          ), s;
      }
      function $(j, H, k, I, B) {
        for (var U = [], Y = 0; Y < x.length; Y++) {
          var ce = x[Y], T = ce(j, H, k, I, B, r);
          if (T == null)
            return null;
          T.data && n(T.data, "expectedType") && U.push(T.data.expectedType);
        }
        var le = U.length > 0 ? ", expected one of type [" + U.join(", ") + "]" : "";
        return new m("Invalid " + I + " `" + B + "` supplied to " + ("`" + k + "`" + le + "."));
      }
      return b($);
    }
    function F() {
      function x(O, W, $, j, H) {
        return z(O[W]) ? null : new m("Invalid " + j + " `" + H + "` supplied to " + ("`" + $ + "`, expected a ReactNode."));
      }
      return b(x);
    }
    function te(x, O, W, $, j) {
      return new m(
        (x || "React class") + ": " + O + " type `" + W + "." + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + j + "`."
      );
    }
    function ne(x) {
      function O(W, $, j, H, k) {
        var I = W[$], B = Z(I);
        if (B !== "object")
          return new m("Invalid " + H + " `" + k + "` of type `" + B + "` " + ("supplied to `" + j + "`, expected `object`."));
        for (var U in x) {
          var Y = x[U];
          if (typeof Y != "function")
            return te(j, H, k, U, G(Y));
          var ce = Y(I, U, j, H, k + "." + U, r);
          if (ce)
            return ce;
        }
        return null;
      }
      return b(O);
    }
    function K(x) {
      function O(W, $, j, H, k) {
        var I = W[$], B = Z(I);
        if (B !== "object")
          return new m("Invalid " + H + " `" + k + "` of type `" + B + "` " + ("supplied to `" + j + "`, expected `object`."));
        var U = t({}, W[$], x);
        for (var Y in U) {
          var ce = x[Y];
          if (n(x, Y) && typeof ce != "function")
            return te(j, H, k, Y, G(ce));
          if (!ce)
            return new m(
              "Invalid " + H + " `" + k + "` key `" + Y + "` supplied to `" + j + "`.\nBad object: " + JSON.stringify(W[$], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(x), null, "  ")
            );
          var T = ce(I, Y, j, H, k + "." + Y, r);
          if (T)
            return T;
        }
        return null;
      }
      return b(O);
    }
    function z(x) {
      switch (typeof x) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !x;
        case "object":
          if (Array.isArray(x))
            return x.every(z);
          if (x === null || a(x))
            return !0;
          var O = d(x);
          if (O) {
            var W = O.call(x), $;
            if (O !== x.entries) {
              for (; !($ = W.next()).done; )
                if (!z($.value))
                  return !1;
            } else
              for (; !($ = W.next()).done; ) {
                var j = $.value;
                if (j && !z(j[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function oe(x, O) {
      return x === "symbol" ? !0 : O ? O["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && O instanceof Symbol : !1;
    }
    function Z(x) {
      var O = typeof x;
      return Array.isArray(x) ? "array" : x instanceof RegExp ? "object" : oe(O, x) ? "symbol" : O;
    }
    function G(x) {
      if (typeof x > "u" || x === null)
        return "" + x;
      var O = Z(x);
      if (O === "object") {
        if (x instanceof Date)
          return "date";
        if (x instanceof RegExp)
          return "regexp";
      }
      return O;
    }
    function N(x) {
      var O = G(x);
      switch (O) {
        case "array":
        case "object":
          return "an " + O;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + O;
        default:
          return O;
      }
    }
    function ie(x) {
      return !x.constructor || !x.constructor.name ? v : x.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, rr;
}
var nr, xn;
function Bc() {
  if (xn) return nr;
  xn = 1;
  var e = Cr();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, nr = function() {
    function n(s, a, c, l, u, d) {
      if (d !== e) {
        var v = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw v.name = "Invariant Violation", v;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, nr;
}
if (process.env.NODE_ENV !== "production") {
  var Yc = To(), Vc = !0;
  ur.exports = Wc()(Yc.isElement, Vc);
} else
  ur.exports = Bc()();
var zc = ur.exports;
const De = /* @__PURE__ */ bi(zc), Oo = hi({}), Rr = ({
  children: e,
  disabled: t,
  size: r = "medium",
  variant: n = "primary",
  variantType: o = "brand",
  ...i
}) => {
  const [s, a] = We(i.open ?? i.defaultOpen ?? !1), c = Rn(null), { portalContainer: l, zIndex: u } = Lc(c);
  return fr(() => {
    a(i.open ?? !1);
  }, [i.open]), /* @__PURE__ */ P.jsx("div", { ref: c, children: /* @__PURE__ */ P.jsx(
    Oo.Provider,
    {
      value: {
        disabled: t,
        dropdownPortal: l,
        dropdownZIndex: u,
        size: r,
        open: s,
        variant: n,
        variantType: o
      },
      children: /* @__PURE__ */ P.jsx(
        Ac,
        {
          ...i,
          onOpenChange: (d) => {
            var v;
            a(d), (v = i.onOpenChange) == null || v.call(i, d);
          },
          children: e
        }
      )
    }
  ) });
}, ut = () => {
  const e = mi(Oo);
  if (!e)
    throw new Error("usePillSelectContext must be used within a RootProvider");
  return e;
};
Rr.displayName = "PillSelectRoot";
Rr.propTypes = {
  /** React nodes rendered inside (Trigger, Content, etc.) */
  children: De.node,
  /** Disables interaction with the component. */
  disabled: De.bool,
  /** Visual size of the component. */
  size: De.oneOf([...Mc]),
  /** Color / intent style variant. */
  variant: De.oneOf([...jc]),
  /** Variant styling family. */
  variantType: De.oneOf([...kc]),
  /** Controlled open state (when set, use onOpenChange from Popover props). */
  open: De.bool,
  /** Initial uncontrolled open state. */
  defaultOpen: De.bool,
  /** Portal parent element for dropdown content. */
  dropdownPortal: De.instanceOf(HTMLElement),
  /** z-index applied to dropdown container. */
  dropdownZIndex: De.number
};
const Hc = ({ children: e }) => {
  const { dropdownPortal: t } = ut();
  return /* @__PURE__ */ P.jsx(_c, { container: t, children: e });
};
var Uc = f.createContext(void 0);
function Xc(e) {
  const t = f.useContext(Uc);
  return e || t || "ltr";
}
function qc(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
function Kc(e, t) {
  return f.useReducer((r, n) => t[r][n] ?? r, e);
}
var Pr = "ScrollArea", [_o, Cl] = vr(Pr), [Zc, ye] = _o(Pr), Do = f.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: r,
      type: n = "hover",
      dir: o,
      scrollHideDelay: i = 600,
      ...s
    } = e, [a, c] = f.useState(null), [l, u] = f.useState(null), [d, v] = f.useState(null), [h, y] = f.useState(null), [m, b] = f.useState(null), [w, E] = f.useState(0), [R, C] = f.useState(0), [g, D] = f.useState(!1), [_, V] = f.useState(!1), L = de(t, (te) => c(te)), F = Xc(o);
    return /* @__PURE__ */ P.jsx(
      Zc,
      {
        scope: r,
        type: n,
        dir: F,
        scrollHideDelay: i,
        scrollArea: a,
        viewport: l,
        onViewportChange: u,
        content: d,
        onContentChange: v,
        scrollbarX: h,
        onScrollbarXChange: y,
        scrollbarXEnabled: g,
        onScrollbarXEnabledChange: D,
        scrollbarY: m,
        onScrollbarYChange: b,
        scrollbarYEnabled: _,
        onScrollbarYEnabledChange: V,
        onCornerWidthChange: E,
        onCornerHeightChange: C,
        children: /* @__PURE__ */ P.jsx(
          pe.div,
          {
            dir: F,
            ...s,
            ref: L,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": R + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Do.displayName = Pr;
var Lo = "ScrollAreaViewport", Mo = f.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, children: n, nonce: o, ...i } = e, s = ye(Lo, r), a = f.useRef(null), c = de(t, a, s.onViewportChange);
    return /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
      /* @__PURE__ */ P.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ P.jsx(
        pe.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...i,
          ref: c,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: s.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: s.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ P.jsx("div", { ref: s.onContentChange, style: { minWidth: "100%", display: "table" }, children: n })
        }
      )
    ] });
  }
);
Mo.displayName = Lo;
var Pe = "ScrollAreaScrollbar", jo = f.forwardRef(
  (e, t) => {
    const { forceMount: r, ...n } = e, o = ye(Pe, e.__scopeScrollArea), { onScrollbarXEnabledChange: i, onScrollbarYEnabledChange: s } = o, a = e.orientation === "horizontal";
    return f.useEffect(() => (a ? i(!0) : s(!0), () => {
      a ? i(!1) : s(!1);
    }), [a, i, s]), o.type === "hover" ? /* @__PURE__ */ P.jsx(Gc, { ...n, ref: t, forceMount: r }) : o.type === "scroll" ? /* @__PURE__ */ P.jsx(Jc, { ...n, ref: t, forceMount: r }) : o.type === "auto" ? /* @__PURE__ */ P.jsx(ko, { ...n, ref: t, forceMount: r }) : o.type === "always" ? /* @__PURE__ */ P.jsx(Tr, { ...n, ref: t }) : null;
  }
);
jo.displayName = Pe;
var Gc = f.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, o = ye(Pe, e.__scopeScrollArea), [i, s] = f.useState(!1);
  return f.useEffect(() => {
    const a = o.scrollArea;
    let c = 0;
    if (a) {
      const l = () => {
        window.clearTimeout(c), s(!0);
      }, u = () => {
        c = window.setTimeout(() => s(!1), o.scrollHideDelay);
      };
      return a.addEventListener("pointerenter", l), a.addEventListener("pointerleave", u), () => {
        window.clearTimeout(c), a.removeEventListener("pointerenter", l), a.removeEventListener("pointerleave", u);
      };
    }
  }, [o.scrollArea, o.scrollHideDelay]), /* @__PURE__ */ P.jsx(Ye, { present: r || i, children: /* @__PURE__ */ P.jsx(
    ko,
    {
      "data-state": i ? "visible" : "hidden",
      ...n,
      ref: t
    }
  ) });
}), Jc = f.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, o = ye(Pe, e.__scopeScrollArea), i = e.orientation === "horizontal", s = Nt(() => c("SCROLL_END"), 100), [a, c] = Kc("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return f.useEffect(() => {
    if (a === "idle") {
      const l = window.setTimeout(() => c("HIDE"), o.scrollHideDelay);
      return () => window.clearTimeout(l);
    }
  }, [a, o.scrollHideDelay, c]), f.useEffect(() => {
    const l = o.viewport, u = i ? "scrollLeft" : "scrollTop";
    if (l) {
      let d = l[u];
      const v = () => {
        const h = l[u];
        d !== h && (c("SCROLL"), s()), d = h;
      };
      return l.addEventListener("scroll", v), () => l.removeEventListener("scroll", v);
    }
  }, [o.viewport, i, c, s]), /* @__PURE__ */ P.jsx(Ye, { present: r || a !== "hidden", children: /* @__PURE__ */ P.jsx(
    Tr,
    {
      "data-state": a === "hidden" ? "hidden" : "visible",
      ...n,
      ref: t,
      onPointerEnter: fe(e.onPointerEnter, () => c("POINTER_ENTER")),
      onPointerLeave: fe(e.onPointerLeave, () => c("POINTER_LEAVE"))
    }
  ) });
}), ko = f.forwardRef((e, t) => {
  const r = ye(Pe, e.__scopeScrollArea), { forceMount: n, ...o } = e, [i, s] = f.useState(!1), a = e.orientation === "horizontal", c = Nt(() => {
    if (r.viewport) {
      const l = r.viewport.offsetWidth < r.viewport.scrollWidth, u = r.viewport.offsetHeight < r.viewport.scrollHeight;
      s(a ? l : u);
    }
  }, 10);
  return Qe(r.viewport, c), Qe(r.content, c), /* @__PURE__ */ P.jsx(Ye, { present: n || i, children: /* @__PURE__ */ P.jsx(
    Tr,
    {
      "data-state": i ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), Tr = f.forwardRef((e, t) => {
  const { orientation: r = "vertical", ...n } = e, o = ye(Pe, e.__scopeScrollArea), i = f.useRef(null), s = f.useRef(0), [a, c] = f.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), l = Fo(a.viewport, a.content), u = {
    ...n,
    sizes: a,
    onSizesChange: c,
    hasThumb: l > 0 && l < 1,
    onThumbChange: (v) => i.current = v,
    onThumbPointerUp: () => s.current = 0,
    onThumbPointerDown: (v) => s.current = v
  };
  function d(v, h) {
    return il(v, s.current, a, h);
  }
  return r === "horizontal" ? /* @__PURE__ */ P.jsx(
    Qc,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const v = o.viewport.scrollLeft, h = En(v, a, o.dir);
          i.current.style.transform = `translate3d(${h}px, 0, 0)`;
        }
      },
      onWheelScroll: (v) => {
        o.viewport && (o.viewport.scrollLeft = v);
      },
      onDragScroll: (v) => {
        o.viewport && (o.viewport.scrollLeft = d(v, o.dir));
      }
    }
  ) : r === "vertical" ? /* @__PURE__ */ P.jsx(
    el,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const v = o.viewport.scrollTop, h = En(v, a);
          i.current.style.transform = `translate3d(0, ${h}px, 0)`;
        }
      },
      onWheelScroll: (v) => {
        o.viewport && (o.viewport.scrollTop = v);
      },
      onDragScroll: (v) => {
        o.viewport && (o.viewport.scrollTop = d(v));
      }
    }
  ) : null;
}), Qc = f.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: n, ...o } = e, i = ye(Pe, e.__scopeScrollArea), [s, a] = f.useState(), c = f.useRef(null), l = de(t, c, i.onScrollbarXChange);
  return f.useEffect(() => {
    c.current && a(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ P.jsx(
    No,
    {
      "data-orientation": "horizontal",
      ...o,
      ref: l,
      sizes: r,
      style: {
        bottom: 0,
        left: i.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: i.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": It(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (i.viewport) {
          const v = i.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(v), Bo(v, d) && u.preventDefault();
        }
      },
      onResize: () => {
        c.current && i.viewport && s && n({
          content: i.viewport.scrollWidth,
          viewport: i.viewport.offsetWidth,
          scrollbar: {
            size: c.current.clientWidth,
            paddingStart: Ot(s.paddingLeft),
            paddingEnd: Ot(s.paddingRight)
          }
        });
      }
    }
  );
}), el = f.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: n, ...o } = e, i = ye(Pe, e.__scopeScrollArea), [s, a] = f.useState(), c = f.useRef(null), l = de(t, c, i.onScrollbarYChange);
  return f.useEffect(() => {
    c.current && a(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ P.jsx(
    No,
    {
      "data-orientation": "vertical",
      ...o,
      ref: l,
      sizes: r,
      style: {
        top: 0,
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": It(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (i.viewport) {
          const v = i.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(v), Bo(v, d) && u.preventDefault();
        }
      },
      onResize: () => {
        c.current && i.viewport && s && n({
          content: i.viewport.scrollHeight,
          viewport: i.viewport.offsetHeight,
          scrollbar: {
            size: c.current.clientHeight,
            paddingStart: Ot(s.paddingTop),
            paddingEnd: Ot(s.paddingBottom)
          }
        });
      }
    }
  );
}), [tl, Io] = _o(Pe), No = f.forwardRef((e, t) => {
  const {
    __scopeScrollArea: r,
    sizes: n,
    hasThumb: o,
    onThumbChange: i,
    onThumbPointerUp: s,
    onThumbPointerDown: a,
    onThumbPositionChange: c,
    onDragScroll: l,
    onWheelScroll: u,
    onResize: d,
    ...v
  } = e, h = ye(Pe, r), [y, m] = f.useState(null), b = de(t, (L) => m(L)), w = f.useRef(null), E = f.useRef(""), R = h.viewport, C = n.content - n.viewport, g = he(u), D = he(c), _ = Nt(d, 10);
  function V(L) {
    if (w.current) {
      const F = L.clientX - w.current.left, te = L.clientY - w.current.top;
      l({ x: F, y: te });
    }
  }
  return f.useEffect(() => {
    const L = (F) => {
      const te = F.target;
      (y == null ? void 0 : y.contains(te)) && g(F, C);
    };
    return document.addEventListener("wheel", L, { passive: !1 }), () => document.removeEventListener("wheel", L, { passive: !1 });
  }, [R, y, C, g]), f.useEffect(D, [n, D]), Qe(y, _), Qe(h.content, _), /* @__PURE__ */ P.jsx(
    tl,
    {
      scope: r,
      scrollbar: y,
      hasThumb: o,
      onThumbChange: he(i),
      onThumbPointerUp: he(s),
      onThumbPositionChange: D,
      onThumbPointerDown: he(a),
      children: /* @__PURE__ */ P.jsx(
        pe.div,
        {
          ...v,
          ref: b,
          style: { position: "absolute", ...v.style },
          onPointerDown: fe(e.onPointerDown, (L) => {
            L.button === 0 && (L.target.setPointerCapture(L.pointerId), w.current = y.getBoundingClientRect(), E.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", h.viewport && (h.viewport.style.scrollBehavior = "auto"), V(L));
          }),
          onPointerMove: fe(e.onPointerMove, V),
          onPointerUp: fe(e.onPointerUp, (L) => {
            const F = L.target;
            F.hasPointerCapture(L.pointerId) && F.releasePointerCapture(L.pointerId), document.body.style.webkitUserSelect = E.current, h.viewport && (h.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), At = "ScrollAreaThumb", $o = f.forwardRef(
  (e, t) => {
    const { forceMount: r, ...n } = e, o = Io(At, e.__scopeScrollArea);
    return /* @__PURE__ */ P.jsx(Ye, { present: r || o.hasThumb, children: /* @__PURE__ */ P.jsx(rl, { ref: t, ...n }) });
  }
), rl = f.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, style: n, ...o } = e, i = ye(At, r), s = Io(At, r), { onThumbPositionChange: a } = s, c = de(
      t,
      (d) => s.onThumbChange(d)
    ), l = f.useRef(void 0), u = Nt(() => {
      l.current && (l.current(), l.current = void 0);
    }, 100);
    return f.useEffect(() => {
      const d = i.viewport;
      if (d) {
        const v = () => {
          if (u(), !l.current) {
            const h = al(d, a);
            l.current = h, a();
          }
        };
        return a(), d.addEventListener("scroll", v), () => d.removeEventListener("scroll", v);
      }
    }, [i.viewport, u, a]), /* @__PURE__ */ P.jsx(
      pe.div,
      {
        "data-state": s.hasThumb ? "visible" : "hidden",
        ...o,
        ref: c,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...n
        },
        onPointerDownCapture: fe(e.onPointerDownCapture, (d) => {
          const h = d.target.getBoundingClientRect(), y = d.clientX - h.left, m = d.clientY - h.top;
          s.onThumbPointerDown({ x: y, y: m });
        }),
        onPointerUp: fe(e.onPointerUp, s.onThumbPointerUp)
      }
    );
  }
);
$o.displayName = At;
var Ar = "ScrollAreaCorner", nl = f.forwardRef(
  (e, t) => {
    const r = ye(Ar, e.__scopeScrollArea), n = !!(r.scrollbarX && r.scrollbarY);
    return r.type !== "scroll" && n ? /* @__PURE__ */ P.jsx(ol, { ...e, ref: t }) : null;
  }
);
nl.displayName = Ar;
var ol = f.forwardRef((e, t) => {
  const { __scopeScrollArea: r, ...n } = e, o = ye(Ar, r), [i, s] = f.useState(0), [a, c] = f.useState(0), l = !!(i && a);
  return Qe(o.scrollbarX, () => {
    var d;
    const u = ((d = o.scrollbarX) == null ? void 0 : d.offsetHeight) || 0;
    o.onCornerHeightChange(u), c(u);
  }), Qe(o.scrollbarY, () => {
    var d;
    const u = ((d = o.scrollbarY) == null ? void 0 : d.offsetWidth) || 0;
    o.onCornerWidthChange(u), s(u);
  }), l ? /* @__PURE__ */ P.jsx(
    pe.div,
    {
      ...n,
      ref: t,
      style: {
        width: i,
        height: a,
        position: "absolute",
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Ot(e) {
  return e ? parseInt(e, 10) : 0;
}
function Fo(e, t) {
  const r = e / t;
  return isNaN(r) ? 0 : r;
}
function It(e) {
  const t = Fo(e.viewport, e.content), r = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, n = (e.scrollbar.size - r) * t;
  return Math.max(n, 18);
}
function il(e, t, r, n = "ltr") {
  const o = It(r), i = o / 2, s = t || i, a = o - s, c = r.scrollbar.paddingStart + s, l = r.scrollbar.size - r.scrollbar.paddingEnd - a, u = r.content - r.viewport, d = n === "ltr" ? [0, u] : [u * -1, 0];
  return Wo([c, l], d)(e);
}
function En(e, t, r = "ltr") {
  const n = It(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, i = t.scrollbar.size - o, s = t.content - t.viewport, a = i - n, c = r === "ltr" ? [0, s] : [s * -1, 0], l = qc(e, c);
  return Wo([0, s], [0, a])(l);
}
function Wo(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (r - e[0]);
  };
}
function Bo(e, t) {
  return e > 0 && e < t;
}
var al = (e, t = () => {
}) => {
  let r = { left: e.scrollLeft, top: e.scrollTop }, n = 0;
  return function o() {
    const i = { left: e.scrollLeft, top: e.scrollTop }, s = r.left !== i.left, a = r.top !== i.top;
    (s || a) && t(), r = i, n = window.requestAnimationFrame(o);
  }(), () => window.cancelAnimationFrame(n);
};
function Nt(e, t) {
  const r = he(e), n = f.useRef(0);
  return f.useEffect(() => () => window.clearTimeout(n.current), []), f.useCallback(() => {
    window.clearTimeout(n.current), n.current = window.setTimeout(r, t);
  }, [r, t]);
}
function Qe(e, t) {
  const r = he(t);
  Le(() => {
    let n = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(n), n = window.requestAnimationFrame(r);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(n), o.unobserve(e);
      };
    }
  }, [e, r]);
}
var sl = Do, cl = Mo, ll = jo, ul = $o;
const Sn = An`
  from { opacity: 0; transform: translateY(-10px) scale(.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`, Cn = An`
  from { opacity: 0; transform: translateY(10px) scale(.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`, wt = "20px", fl = $e.div`
  display: flex;
  flex-direction: column;
  width: var(--radix-popover-trigger-width);
  max-height: min(300px, var(--radix-popover-content-available-height));
  box-shadow: 0 4px 26px 0 rgba(0, 0, 0, 0.1);
  height: fit-content;
  background-color: ${({ theme: e }) => e.colors.neutral[100]};
  border-radius: ${({ theme: e }) => e.borders.radius.xs};
  overflow: hidden;
  z-index: ${({ zIndex: e }) => e + 1e3};
  &[data-state="open"][data-side="top"] {
    animation: ${Cn} 960ms cubic-bezier(0.16, 1, 0.3, 1);
  }
  &[data-state="open"][data-side="bottom"] {
    animation: ${Sn} 960ms cubic-bezier(0.16, 1, 0.3, 1);
  }
  &[data-state="closed"][data-side="top"] {
    animation: ${Cn} 440ms cubic-bezier(0.4, 0.15, 0.6, 0.85)
      reverse;
  }
  &[data-state="closed"][data-side="bottom"] {
    animation: ${Sn} 440ms cubic-bezier(0.4, 0.15, 0.6, 0.85)
      reverse;
  }
`, dl = $e(sl)`
  flex: 1 1 auto;
  overflow: scroll;
  padding: ${({ theme: e }) => e.spacings.xs5};
  ${({ isContentScrollable: e, showTopFade: t, showBottomFade: r }) => e ? `
    /* Keep -webkit- for Safari */
    -webkit-mask-image: linear-gradient(
      to bottom,
      ${t ? "transparent" : "black"} 0%,
      black ${t ? wt : "0px"},
      black calc(100% - ${r ? wt : "0px"}),
      ${r ? "transparent" : "black"} 100%
    );
    mask-image: linear-gradient(
      to bottom,
      ${t ? "transparent" : "black"} 0%,
      black ${t ? wt : "0px"},
      black calc(100% - ${r ? wt : "0px"}),
      ${r ? "transparent" : "black"} 100%
    );
    mask-size: 100% 100%;
    mask-repeat: no-repeat;
  ` : ""}
`, pl = Pn(
  ({ align: e = "end", children: t, className: r, style: n, ...o }, i) => {
    const { dropdownZIndex: s } = ut(), a = Rn(null), [c, l] = We(!1), [u, d] = We(!1), [v, h] = We(!1), y = gi(() => {
      const m = a.current;
      if (!m) return;
      const b = m.scrollHeight > m.clientHeight;
      if (l(b), !b) {
        d(!1), h(!1);
        return;
      }
      const { scrollTop: w, scrollHeight: E, clientHeight: R } = m;
      d(w > 0), h(w + R < E);
    }, []);
    return fr(() => {
      y();
      const m = a.current;
      if (!m) return;
      const b = new ResizeObserver(y);
      return b.observe(m), m.addEventListener("scroll", y), () => {
        b.disconnect(), m.removeEventListener("scroll", y);
      };
    }, [t, y]), /* @__PURE__ */ P.jsx(
      Dc,
      {
        ref: i,
        asChild: !0,
        sideOffset: 4,
        hideWhenDetached: !0,
        align: e,
        children: /* @__PURE__ */ P.jsx(
          fl,
          {
            isContentScrollable: c,
            zIndex: s,
            className: r,
            style: n,
            showTopFade: u,
            showBottomFade: v,
            ...o,
            children: /* @__PURE__ */ P.jsxs(
              dl,
              {
                isContentScrollable: c,
                showTopFade: u,
                showBottomFade: v,
                ref: a,
                style: { paddingBottom: "8px" },
                children: [
                  /* @__PURE__ */ P.jsx(cl, { asChild: !0, children: t }),
                  /* @__PURE__ */ P.jsx(ll, { orientation: "vertical", children: /* @__PURE__ */ P.jsx(ul, {}) })
                ]
              }
            )
          }
        )
      }
    );
  }
), vl = $e(_n)`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: unset;
`, Yo = ({
  children: e,
  variant: t = "body4",
  ...r
}) => {
  const { variantType: n, disabled: o } = ut(), i = dr(() => o ? {
    brand: "secondary.80",
    neutral: "neutral.70"
  }[n] : {
    brand: "secondary.40",
    neutral: "neutral.40"
  }[n], [o, n]);
  return /* @__PURE__ */ P.jsx(vl, { variant: t, weight: 600, color: i, ...r, children: e });
}, Vo = ({ size: e = 16, ...t }) => {
  const r = On(), { disabled: n, variantType: o } = ut(), i = dr(() => n ? {
    brand: r.colors.secondary[80],
    neutral: r.colors.neutral[70]
  }[o] : {
    brand: r.colors.secondary[40],
    neutral: r.colors.neutral[40]
  }[o], [n, o]);
  return /* @__PURE__ */ P.jsx(Dn, { size: e, color: i, ...t });
}, hl = $e(_n)`
  flex: 1;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
`, zo = ({
  children: e,
  variant: t = "caption",
  ...r
}) => /* @__PURE__ */ P.jsx(
  hl,
  {
    variant: t,
    weight: 400,
    color: "neutral.50",
    ...r,
    children: e
  }
), Ho = Pn((e, t) => /* @__PURE__ */ P.jsx(Oc, { ...e, ref: t }));
Ho.displayName = "BaseTrigger";
const ml = $e.div`
  display: flex;
  align-items: center;
  gap: ${({ theme: e }) => e.spacings.xs5};
  justify-content: space-between;
`, gl = $e(Ho)`
  height: ${({ $height: e }) => e};
  padding: ${({ theme: e }) => `0 ${e.spacings.xs3}`};
  border-radius: ${({ theme: e }) => e.borders.radius.xl};
  border: ${({ theme: e, variant: t, variantType: r }) => `${e.borders.width.xs2} solid ${{
  primary: {
    brand: e.colors.secondary[95],
    neutral: e.colors.neutral[90]
  },
  secondary: {
    brand: e.colors.neutral[90],
    neutral: e.colors.neutral[90]
  }
}[t][r]}`};
  background-color: ${({ theme: e, variant: t, variantType: r }) => ({
  primary: {
    brand: e.colors.secondary[99],
    neutral: e.colors.neutral[95]
  },
  secondary: {
    brand: e.colors.neutral[100],
    neutral: e.colors.neutral[100]
  }
})[t][r]};
  cursor: pointer;
  font-weight: 500;
  width: 200px;
  outline-offset: -1px;
  &:hover:not(:disabled) {
    background-color: ${({ theme: e, variant: t, variantType: r }) => ({
  primary: {
    brand: e.colors.secondary[95],
    neutral: e.colors.neutral[90]
  },
  secondary: {
    brand: e.colors.neutral[100],
    neutral: e.colors.neutral[100]
  }
})[t][r]};
    outline: ${({ theme: e, variant: t, variantType: r }) => `${e.borders.width.s} solid ${{
  primary: {
    brand: e.colors.secondary[80],
    neutral: e.colors.neutral[80]
  },
  secondary: {
    brand: e.colors.secondary[80],
    neutral: e.colors.neutral[70]
  }
}[t][r]}`};
  }
  &:focus-visible,
  &:active:not(:disabled),
  &[data-state="open"],
  &[data-state="open"]:hover {
    background-color: ${({ theme: e, variant: t, variantType: r }) => ({
  primary: {
    brand: e.colors.secondary[99],
    neutral: e.colors.neutral[95]
  },
  secondary: {
    brand: e.colors.neutral[100],
    neutral: e.colors.neutral[100]
  }
})[t][r]};
    outline: ${({ theme: e, variant: t, variantType: r }) => `${e.borders.width.s} solid ${{
  primary: {
    brand: e.colors.secondary[70],
    neutral: e.colors.neutral[60]
  },
  secondary: {
    brand: e.colors.secondary[70],
    neutral: e.colors.neutral[60]
  }
}[t][r]}`};
  }
  &:disabled {
    background-color: ${({ theme: e, variant: t, variantType: r }) => ({
  primary: {
    brand: e.colors.neutral[95],
    neutral: e.colors.neutral[95]
  },
  secondary: {
    brand: e.colors.neutral[95],
    neutral: e.colors.neutral[95]
  }
})[t][r]};
    border: ${({ theme: e, variant: t, variantType: r }) => `${e.borders.width.xs2} solid ${{
  primary: {
    brand: e.colors.secondary[95],
    neutral: e.colors.neutral[90]
  },
  secondary: {
    brand: e.colors.neutral[90],
    neutral: e.colors.neutral[90]
  }
}[t][r]}`};
    cursor: not-allowed;
  }
`, Uo = $e.div`
  display: flex;
  align-items: center;
  gap: ${({ theme: e }) => e.spacings.xs4};
  min-width: 0;
`, yl = $e.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${({ theme: e }) => e.spacings.xs4};
  min-width: 0;
`, Xo = it.forwardRef(
  ({ className: e, style: t, children: r, ...n }, o) => {
    const i = On(), { disabled: s, open: a, size: c, variant: l, variantType: u } = ut();
    let d, v, h;
    const y = [];
    it.Children.forEach(r, (b) => {
      if (it.isValidElement(b))
        switch (b.type) {
          case Vo:
            d = b;
            break;
          case Yo:
            v = b;
            break;
          case zo:
            h = b;
            break;
          default:
            y.push(b);
            break;
        }
    });
    const m = dr(
      () => ({
        medium: "40px",
        small: "32px"
      })[c],
      [c]
    );
    return /* @__PURE__ */ P.jsxs(
      gl,
      {
        ref: o,
        $height: m,
        disabled: s,
        variant: l,
        variantType: u,
        className: e,
        style: t,
        ...n,
        children: [
          /* @__PURE__ */ P.jsxs(ml, { children: [
            (v || d) && /* @__PURE__ */ P.jsxs(Uo, { children: [
              d,
              v
            ] }),
            /* @__PURE__ */ P.jsxs(yl, { children: [
              h,
              /* @__PURE__ */ P.jsx(
                Dn,
                {
                  color: i.colors.neutral[30],
                  size: 16,
                  name: a ? "IconChevronUp" : "IconChevronDown"
                }
              )
            ] })
          ] }),
          y
        ]
      }
    );
  }
);
Xo.displayName = "PillSelectTrigger";
const Rl = {
  Root: Rr,
  Label: Yo,
  LabelIconWrapper: Uo,
  MainIcon: Vo,
  Meta: zo,
  Dropdown: Hc,
  DropdownContent: pl,
  Trigger: Xo
};
export {
  Rl as default
};
//# sourceMappingURL=flamingo-ui-pill-select.es.js.map
